export const portaleTurystyczne = {
  page: {
    response: {
      innepanstwa: [
        {
          maindata: {
            name: "Austria",
            urlgeo: "/austria.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "austria",
            grupa: "1",
            url: "https://www.austria.pl",
            photo: "AT-01.jpg",
            cenamin: "82"
          },
          Opis:
            "Alpy i znakomita infrastruktura narciarska czynią ten kraj rajem dla narciarzy i snowboardzistów. Na amatorów letnich wypraw czekają kilometry szlaków górskich, tras rowerowych oraz wyciągów. Wiedeń, park rozrywki Prater oraz Salzburg Mozarta to obowiązkowe punkty programów wycieczek objazdowych po Austrii.",
          Polecamy: [
            {
              name: "Wiedeń",
              url: "https://www.austria.pl/wieden.xml"
            },
            {
              name: "park rozrywki Prater",
              url: "https://www.austria.pl/wieden-wiener-prater.xml"
            },
            {
              name: "Salzburg",
              url: "https://www.austria.pl/salzburg.xml"
            },
            {
              name: "Alpy",
              url: ""
            },
            {
              name: "Pałac Schönbrunn",
              url: ""
            },
            {
              name: "Pałac Hofburg",
              url: "https://www.austria.pl/wieden-palac-hofburg.xml"
            },
            {
              name: "Belweder",
              url: ""
            },
            {
              name: "dom Mozarta",
              url: ""
            },
            {
              name: "Dolina Wachau i trasa kolei wysokogórskiej (UNESCO)",
              url: "https://www.austria.pl/wachau-dolina-dunaju.xml"
            },
            {
              name: "jeziora w Karyntii",
              url: "https://www.austria.pl/karyntia.xml"
            }
          ],
          Atrakcje: [
            {
              name: "narciarstwo i snowboard",
              url: "https://www.austria.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "wycieczki górskie",
              url: ""
            },
            {
              name: "trasy rowerowe",
              url: ""
            },
            {
              name: "nordic walking",
              url: "https://www.austria.pl/rodzaj-oferty/nordic-walking.xml"
            },
            {
              name: "wycieczki piesze",
              url: ""
            },
            {
              name: "city breaks",
              url: "https://www.austria.pl/rodzaj-oferty/city-breaks.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Bali",
            urlgeo: "/bali.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "bali",
            grupa: "4",
            url: "https://www.bali.pl",
            photo: "BL-01.jpg",
            cenamin: "3910"
          },
          Opis:
            "Wyspa w Indonezji znana z rajskich krajobrazów – białych plaż, turkusowej wody, egzotycznych roślin i kolorowych kwiatów, tropikalnych lasów i wulkanów. Bali wyróżnia bogata kultura, mistyczne świątynie, malownicze tarasy ryżowe, otwarci i serdeczni mieszkańcy. Panują tu znakomite warunki do surfowania i nurkowania.",
          Polecamy: [
            {
              name: "Monkey Forest",
              url: "https://www.bali.pl/monkey-forest.xml"
            },
            {
              name: "Świątynia Pura Taman Ayun",
              url: "https://www.bali.pl/pura-taman-ayun.xml"
            },
            {
              name: "Archipelag Gili w Zachodnim Lomboku",
              url: "https://www.bali.pl/zachodni-lombok.xml"
            },
            {
              name: "Świątynia Pura Tanah Lot",
              url: "https://www.bali.pl/pura-tanah-lot.xml"
            },
            {
              name: "Ujung i Pływający Pałac",
              url: "https://www.bali.pl/ujung.xml"
            },
            {
              name: "region Bangli",
              url: "https://www.bali.pl/region-bangli.xml"
            }
          ],
          Atrakcje: [
            {
              name: "luksusowe hotele i SPA",
              url: "https://www.bali.pl/rodzaj-oferty/wakacje-w-spa-na-bali.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.bali.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie-na-bali.xml"
            },
            {
              name: "windsurfing i kitesurfing",
              url:
                "https://www.bali.pl/rodzaj-oferty/windsurfing-kitesurfing-na-bali.xml"
            },
            {
              name: "żeglowanie",
              url: "https://www.bali.pl/rodzaj-oferty/zeglarstwo-na-bali.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Brazylia",
            urlgeo: "/brazylia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "brazylia",
            grupa: "10",
            url: "https://www.brazylia.com.pl",
            photo: "BR-01.jpg",
            cenamin: "4129"
          },
          Opis:
            "Ojczyzna samby, piłki nożnej i kawy. Najpopularniejsze atrakcje turystyczne kraju – pomnik Chrystusa i plaża Copacabana – znajdują się w Rio de Janeiro, w którym co roku odbywa się czterodniowy karnawał. Do największych ciekawostek przyrodniczych Brazylii zalicza się amazońską dżunglę oraz progi wodne i wodospady w Sul.",
          Polecamy: [
            {
              name: "Rio de Janeiro",
              url: "https://www.brazylia.com.pl/rio-de-janeiro.xml"
            },
            {
              name: "Sao Paulo",
              url: "https://www.brazylia.com.pl/sao-paulo.xml"
            },
            {
              name: "plaże Fortalezy",
              url: "https://www.brazylia.com.pl/ceara-fortaleza.xml"
            },
            {
              name: "wodospady Iguaçu",
              url: "https://www.brazylia.com.pl/wodospady-iguazu.xml"
            },
            {
              name: "Salvador da Bahia",
              url: "https://www.brazylia.com.pl/salvador-da-bahia.xml"
            }
          ],
          Atrakcje: [
            {
              name: "najpiękniejsze piaszczyste plaże świata",
              url:
                "https://www.brazylia.com.pl/rodzaj-oferty/hotele-blisko-plazy.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.brazylia.com.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "windsurfing i kitesurfing",
              url:
                "https://www.brazylia.com.pl/rodzaj-oferty/windsurfing-kitesurfing.xml"
            },
            {
              name: "paralotniarstwo",
              url: ""
            },
            {
              name: "wyprawy do Amazonii",
              url: ""
            },
            {
              name: "zwiedzanie w rytmie samby",
              url:
                "https://www.brazylia.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Bułgaria",
            urlgeo: "/bulgaria.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "bulgaria",
            grupa: "1",
            url: "https://www.bulgaria.pl",
            photo: "BG-01.jpg",
            cenamin: "99"
          },
          Opis:
            "Doskonałe warunki na rodzinne i niedrogie wakacje: latem – ciepłe, spokojne morze oraz długie, szerokie plaże w Słonecznym Brzegu i Złotych Piaskach, zimą – szaleństwo na stokach narciarskich w górach Pirin i Riła. Miasto-muzeum Nessebar, historyczna Warna lub Święty Włas to jedne z najciekawszych atrakcji Bułgarii.",
          Polecamy: [
            {
              name: "Nessebar",
              url: "https://www.bulgaria.pl/nesebyr.xml"
            },
            {
              name: "Sozopol",
              url: "https://www.bulgaria.pl/sozopol.xml"
            },
            {
              name: "Warna",
              url: "https://www.bulgaria.pl/warna.xml"
            },
            {
              name: "Góry Bałkan",
              url: "https://www.bulgaria.pl/gory-balkan-stara-planina.xml"
            },
            {
              name: "Góry Pirin",
              url: "https://www.bulgaria.pl/gory-pirin.xml"
            },
            {
              name: "Góry Riła",
              url: "https://www.bulgaria.pl/masyw-rila.xml"
            },
            {
              name: "Słoneczny Brzeg",
              url: "https://www.bulgaria.pl/sloneczny-brzeg-nesebyr.xml"
            },
            {
              name: "Złote Piaski",
              url: "https://www.bulgaria.pl/zlote-piaski-albena.xml"
            },
            {
              name: "Sofia i okolice",
              url: "https://www.bulgaria.pl/region-sofia.xml"
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne",
              url:
                "https://www.bulgaria.pl/rodzaj-oferty/sporty-wodne-w-bulgarii.xml"
            },
            {
              name: "nurkowanie",
              url: ""
            },
            {
              name: "wędrówki górskie",
              url: ""
            },
            {
              name: "narciarstwo",
              url:
                "https://www.bulgaria.pl/rodzaj-oferty/kurorty-narciarskie-w-bulgarii.xml"
            },
            {
              name: "wycieczki ze zwiedzaniem",
              url:
                "https://www.bulgaria.pl/rodzaj-oferty/wycieczki-objazdowe-po-bulgarii.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Chorwacja",
            urlgeo: "/chorwacja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "chorwacja",
            grupa: "1",
            url: "https://www.chorwacja.pl",
            photo: "HR-01.jpg",
            cenamin: "107"
          },
          Opis:
            "Góry schodzące do błękitnego morza, tysiąc wysp, włoska i wenecka architektura, wodospady, kameralne plaże oraz zachwycające krajobrazy. Śródziemnomorska kuchnia połączona z bałkańskimi specjałami. Krainy pachnące winem, lawendą i oliwkami. Słowiański raj dla plażowiczów i miłośników sportów wodnych.",
          Polecamy: [
            {
              name: "Dubrownik",
              url: "https://www.chorwacja.pl/dubrownik.xml"
            },
            {
              name: "Makarska",
              url: "https://www.chorwacja.pl/makarska.xml"
            },
            {
              name: "Split",
              url: "https://www.chorwacja.pl/split.xml"
            },
            {
              name: "Trogir",
              url: "https://www.chorwacja.pl/trogir.xml"
            },
            {
              name: "Jeziora Plitwickie",
              url: "https://www.chorwacja.pl/jeziora-plitwickie-plitwice.xml"
            },
            {
              name: "Krka",
              url: "https://www.chorwacja.pl/krka.xml"
            },
            {
              name: "Istria",
              url: "https://www.chorwacja.pl/istria.xml"
            },
            {
              name: "Pula",
              url: "https://www.chorwacja.pl/pula.xml"
            },
            {
              name: "Brijuni",
              url: "https://www.chorwacja.pl/wyspy-brijuni.xml"
            },
            {
              name: "Hvar",
              url: "https://www.chorwacja.pl/wyspa-hvar.xml"
            },
            {
              name: "Pag",
              url: "https://www.chorwacja.pl/wyspa-pag.xml"
            },
            {
              name: "Korčula",
              url: "https://www.chorwacja.pl/wyspa-korcula.xml"
            }
          ],
          Atrakcje: [
            {
              name: "żeglowanie",
              url:
                "https://www.chorwacja.pl/rodzaj-oferty/zeglarstwo-w-chorwacji.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.chorwacja.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie-w-chorwacji.xml"
            },
            {
              name: "windsurfing",
              url:
                "https://www.chorwacja.pl/rodzaj-oferty/kite-windsurfing-w-chorwacji.xml"
            },
            {
              name: "wędkowanie",
              url: ""
            },
            {
              name: "trekking",
              url: ""
            },
            {
              name: "objazdy ze zwiedzaniem",
              url:
                "https://www.chorwacja.pl/rodzaj-oferty/wycieczki-objazdowe-po-chorwacji.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Cypr",
            urlgeo: "/wyspa-cypr.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "cypr",
            grupa: "1",
            url: "https://www.cypr.net.pl",
            photo: "CY-01.jpg",
            cenamin: "589"
          },
          Opis:
            "Wyspa dwóch kultur, na której, według mitu, wyłoniła się Afrodyta – bogini miłości. Cypr to nie tylko antyczne zabytki, malownicze krajobrazy, skaliste wybrzeże, plaże oraz pyszna grecka kuchnia, lecz także wiele możliwości aktywnego spędzania czasu – nurkowanie, sporty wodne i zwiedzanie.",
          Polecamy: [
            {
              name: "Półwysep Akamas",
              url: ""
            },
            {
              name: "Paphos",
              url: "https://www.cypr.net.pl/pafos.xml"
            },
            {
              name: "Turecki Cypr Północny",
              url: "https://www.cypr.net.pl/cypr-polnocny.xml"
            },
            {
              name: "Nikozja",
              url: "https://www.cypr.net.pl/cypr-centralny-nikozja.xml"
            },
            {
              name: "Góry Troodos",
              url: "https://www.cypr.net.pl/gory-troodos.xml"
            },
            {
              name: "malowane kościoły w górach Troodos",
              url: "https://www.cypr.net.pl/malowane-koscioly-troodos.xml"
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne",
              url: "https://www.cypr.net.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "wędrówki górskie",
              url: ""
            },
            {
              name: "jeep safari w górach Troodos",
              url: ""
            },
            {
              name: "golf",
              url:
                "https://www.cypr.net.pl/rodzaj-oferty/pole-golfowe-blisko-hotelu.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.cypr.net.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Czarnogóra",
            urlgeo: "/czarnogora.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "czarnogora",
            grupa: "1",
            url: "https://www.czarnogora.pl",
            photo: "MN-01.jpg",
            cenamin: "278"
          },
          Opis:
            "Górzyste wybrzeże, piaszczyste plaże, średniowieczne twierdze, weneckie miasteczka, wioski rybackie. Dzikie pasma górskie Durmitoru, Bjelasicy i Prokletije. Malownicze kaniony, jeziora polodowcowe i Jezioro Szkoderskie. Czarnogóra to maleńki kraj pełen różnorodności!",
          Polecamy: [
            {
              name: "Herceg Novi",
              url: "https://www.czarnogora.pl/herceg-novi.xml"
            },
            {
              name: "Zatoka Kotorska",
              url: "https://www.czarnogora.pl/region-zatoki-kotorskiej.xml"
            },
            {
              name: "Kotor",
              url: "https://www.czarnogora.pl/kotor.xml"
            },
            {
              name: "Budwa",
              url: "https://www.czarnogora.pl/budva.xml"
            },
            {
              name: "Sveti Stefan",
              url: "https://www.czarnogora.pl/sveti-stefan.xml"
            },
            {
              name: "Ulcinj",
              url: "https://www.czarnogora.pl/ulcinj-riwiera.xml"
            },
            {
              name: "Žabljak",
              url: "https://www.czarnogora.pl/zabljak.xml"
            },
            {
              name: "Jezioro Szkoderskie",
              url:
                "https://www.czarnogora.pl/park-narodowy-jezioro-skadarskie.xml"
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne",
              url: "https://www.czarnogora.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.czarnogora.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "plażowanie",
              url:
                "https://www.czarnogora.pl/rodzaj-oferty/hotele-blisko-plazy.xml"
            },
            {
              name: "rafting na rzece Tara",
              url: ""
            },
            {
              name: "turystyka górska",
              url: ""
            },
            {
              name: "narty",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Czechy",
            urlgeo: "/czechy.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "czechy",
            grupa: "1",
            url: "https://www.czechy.pl",
            photo: "CZ-01.jpg",
            cenamin: "105"
          },
          Opis:
            "Praga ze swymi zabytkami i charakterystycznymi czerwonymi dachami, skalne miasta Czeskiego Raju, światowej sławy uzdrowiska i gorące źródła, świetna infrastruktura narciarska oraz piwo i tradycyjne przysmaki kuchni czeskiej - to tylko niektóre z zalet tego pięknego kraju. Popularna destynacja na wyjazdy weekendowe.",
          Polecamy: [
            {
              name: "Praga",
              url: "https://www.czechy.pl/praga.xml"
            },
            {
              name: "Czeski Krumlov",
              url: "https://www.czechy.pl/czeski-krumlov.xml"
            },
            {
              name: "Karlowe Wary",
              url: "https://www.czechy.pl/karlovy-vary-karlowe-wary.xml"
            },
            {
              name: "Kutna Hora",
              url: "https://www.czechy.pl/kutna-hora.xml"
            },
            {
              name: "Harrachov",
              url: "https://www.czechy.pl/harrachov.xml"
            }
          ],
          Atrakcje: [
            {
              name: "trekking",
              url: ""
            },
            {
              name: "trasy rowerowe",
              url: ""
            },
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "wyjazdy sportowe",
              url: "https://www.czechy.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "narty",
              url: "https://www.czechy.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "city breaks",
              url: "https://www.czechy.pl/rodzaj-oferty/city-breaks.xml"
            },
            {
              name: "nordic walking",
              url: "https://www.czechy.pl/rodzaj-oferty/nordic-walking.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Egipt",
            urlgeo: "/egipt.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "egipt",
            grupa: "6",
            url: "https://www.egipt.info.pl",
            photo: "EG-01.jpg",
            cenamin: "459"
          },
          Opis:
            "Jedna z najpopularniejszych destynacji przez cały rok. Piramidy, Sfinks, Kair, rafa koralowa na Morzu Czerwonym, safari na pustyni - to główne atrakcje kraju. Egipt jest nie tylko rajem dla spragnionych wrażeń, lecz także idealnym wyborem na rodzinne wakacje. Odpocząć można w jednym z wielu luksusowych hoteli.",
          Polecamy: [
            {
              name: "Hurghada",
              url: "https://www.egipt.info.pl/hurghada-el-gouna.xml"
            },
            {
              name: "Sharm El Sheikh",
              url: "https://www.egipt.info.pl/sharm-el-sheikh-riwiera.xml"
            },
            {
              name: "Luxor",
              url: "https://www.egipt.info.pl/luxor.xml"
            },
            {
              name: "Karnak",
              url: "https://www.egipt.info.pl/karnak.xml"
            },
            {
              name: "Dolina Królów w Tebach",
              url: "https://www.egipt.info.pl/teby.xml"
            },
            {
              name: "Kair",
              url: "https://www.egipt.info.pl/kair.xml"
            },
            {
              name: "Giza",
              url: "https://www.egipt.info.pl/giza.xml"
            }
          ],
          Atrakcje: [
            {
              name: "kite i windsurfing",
              url:
                "https://www.egipt.info.pl/rodzaj-oferty/kite-windsurfing-w-egipcie.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.egipt.info.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie-w-egipcie.xml"
            },
            {
              name: "rejs po Nilu",
              url:
                "https://www.egipt.info.pl/rodzaj-oferty/rejsy-po-nilu-w-egipcie.xml"
            },
            {
              name: "wyprawy na Saharę",
              url: ""
            },
            {
              name: "objazdy",
              url:
                "https://www.egipt.info.pl/rodzaj-oferty/wycieczki-objazdowe-po-egipcie.xml"
            },
            {
              name: "sporty wodne",
              url:
                "https://www.egipt.info.pl/rodzaj-oferty/sporty-wodne-w-egipcie.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Emiraty Arabskie",
            urlgeo: "/emiraty-arabskie.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "emiratyarabskie",
            grupa: "2",
            url: "https://www.emiratyarabskie.pl",
            photo: "AE-01.jpg",
            cenamin: "569"
          },
          Opis:
            "Kraj kontrastów i różnorodności kojarzony głównie z luksusem i 7‑gwiazdkowym hotelem w Dubaju oraz z pustynią, która pokrywa ponad 90% powierzchni kraju. Liczne oazy, piękne plaże, wymyślne hotele w Dubaju, tradycyjne wioski beduińskie – Emiraty Arabskie łączą w sobie luksus z przygodą! Dobre warunki do nurkowania.",
          Polecamy: [
            {
              name: "Dubaj",
              url: "https://www.emiratyarabskie.pl/dubaj-city.xml"
            },
            {
              name: "Jumeirah Beac",
              url: "https://www.emiratyarabskie.pl/jumeirah.xml"
            },
            {
              name: "Abu Dabi",
              url: "https://www.emiratyarabskie.pl/abu-dhabi.xml"
            },
            {
              name: "pustynne oazy",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne",
              url:
                "https://www.emiratyarabskie.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.emiratyarabskie.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "przejażdżki na wielbłądach",
              url: ""
            },
            {
              name: "objazdowe i zwiedzanie",
              url:
                "https://www.emiratyarabskie.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "safari",
              url: ""
            },
            {
              name: "luksusowe wczasy",
              url:
                "https://www.emiratyarabskie.pl/rodzaj-oferty/luksusowe-wczasy.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Francja",
            urlgeo: "/francja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "francja",
            grupa: "1",
            url: "https://www.francja.pl",
            photo: "FR-01.jpg",
            cenamin: "82"
          },
          Opis:
            "Wyrafinowana kultura i sztuka, także kulinarna, winnice, perfumy i pola lawendy! Szyk Paryża, luksus Lazurowego Wybrzeża, festiwale muzyczne, filmowe i teatralne, tajemnicze średniowieczne zamki i miasta, wysokie Alpy z licznymi lodowcami – Francja to wizytówka europejskiej kultury, kraj malowniczych krajobrazów i ciekawej historii.",
          Polecamy: [
            {
              name: "Paryż",
              url: "https://www.francja.pl/paryz-metropolia.xml"
            },
            {
              name: "Lazurowe Wybrzeże",
              url: "https://www.francja.pl/lazurowe-wybrzeze.xml"
            },
            {
              name: "Cannes",
              url: "https://www.francja.pl/cannes.xml"
            },
            {
              name: "zamki nad Loarą",
              url: "https://www.francja.pl/region-loary.xml"
            },
            {
              name: "Korsyka",
              url: "https://www.francja.pl/korsyka.xml"
            },
            {
              name: "Alpy",
              url: "https://www.francja.pl/alpy-francuskie.xml"
            }
          ],
          Atrakcje: [
            {
              name: "narty i snowboard",
              url: "https://www.francja.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "plazowanie",
              url:
                "https://www.francja.pl/rodzaj-oferty/hotele-blisko-plazy.xml"
            },
            {
              name: "sporty wodne",
              url: "https://www.francja.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "luksusowe wczasy",
              url: ""
            },
            {
              name: "city breaks",
              url: "https://www.francja.pl/rodzaj-oferty/city-breaks.xml"
            },
            {
              name: "życie nocne",
              url: "https://www.francja.pl/rodzaj-oferty/zycie-nocne.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Gambia",
            urlgeo: "/gambia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "gambia",
            grupa: "6",
            url: "https://www.gambia.com.pl",
            photo: "GM-01.jpg",
            cenamin: "3350"
          },
          Opis:
            "Najmniejsze państwo na kontynencie afrykańskim i mało znany skrawek świata! Kolonialna architektura oraz muzułmańska kultura wpływają na specyficzną atmosferę kraju. Lasy galeriowe, sawanny, piaszczyste plaże, parki narodowe, dolina rzeki Gambii – to tylko niektóre z atrakcji przyrodniczych kraju.",
          Polecamy: [
            {
              name: "Banjul",
              url: "https://www.gambia.com.pl/banjul.xml"
            },
            {
              name: "plaże Kotu i Kololi",
              url: ""
            },
            {
              name: "dolina rzeki Gambii",
              url: "https://www.gambia.com.pl/central-upper-river.xml"
            },
            {
              name: "lasy galeriowe",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "trekking",
              url: ""
            },
            {
              name: "sporty wodne",
              url: ""
            },
            {
              name: "wędkowanie",
              url: ""
            },
            {
              name: "tramping",
              url: ""
            },
            {
              name: "rafting",
              url: ""
            },
            {
              name: "spływy",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Grecja",
            urlgeo: "/grecja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "grecja",
            grupa: "1",
            url: "https://www.grecja.com.pl",
            photo: "GR-01.jpg",
            cenamin: "219"
          },
          Opis:
            "Turystyczny raj! Jedna z najstarszych cywilizacji i najbogatszych kultur świata. Grecja to nie tylko piękne morze, plaże, słońce, wulkaniczne wyspy i kurorty, lecz także – filozofia, mitologia, sztuka, architektura, kulinaria... Na aktywnych czeka Góra Olimp, Półwysep Athos oraz Wąwóz Samaria!",
          Polecamy: [
            {
              name: "antyczne Ateny",
              url: "https://www.grecja.com.pl/ateny.xml"
            },
            {
              name: "wąwóz Samaria",
              url: "https://www.grecja.com.pl/wawoz-samaria.xml"
            },
            {
              name: "Delfy",
              url: "https://www.grecja.com.pl/delfy.xml"
            },
            {
              name: "Meteory",
              url: "https://www.grecja.com.pl/meteory.xml"
            },
            {
              name: "Athos",
              url: "https://www.grecja.com.pl/athos.xml"
            }
          ],
          Atrakcje: [
            {
              name: "windsurfing na Rodos",
              url:
                "https://www.grecja.com.pl/rodzaj-oferty/kite-windsurfing-w-grecji.xml"
            },
            {
              name: "trekking na Krecie",
              url: ""
            },
            {
              name: "sporty wodne",
              url:
                "https://www.grecja.com.pl/rodzaj-oferty/sporty-wodne-w-grecji.xml"
            },
            {
              name: "wypoczynek nad samym morzem",
              url:
                "https://www.grecja.com.pl/rodzaj-oferty/kurorty-nadmorskie-w-grecji.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.grecja.com.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie-w-grecji.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.grecja.com.pl/rodzaj-oferty/wycieczki-objazdowe-po-grecji.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Hawaje",
            urlgeo: "/hawaje.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "hawaje",
            grupa: "11",
            url: "https://www.hawaje.com.pl",
            photo: "HA-01.jpg",
            cenamin: "6099"
          },
          Opis:
            "Należące do USA wyspy na Pacyfiku, często nazywane stanem Aloha. Mekka dla nurków i miłośników surfingu. Hawaje to ciepłe koralowe morze, rafy, wysokie wulkaniczne góry z kanionami i białe plaże oraz nowoczesne Honolulu i słynny Pearl Harbour. Lokalny koloryt i kultura polinezyjska jest dodatkową atrakcją wysp. Wakacyjny raj!",
          Polecamy: [
            {
              name: "Waikiki",
              url: "https://www.hawaje.com.pl/oahu-waikiki.xml"
            },
            {
              name: "Honolulu na Oahu",
              url: "https://www.hawaje.com.pl/oahu-honolulu.xml"
            },
            {
              name: "Molokai",
              url: "https://www.hawaje.com.pl/wyspa-molokai.xml"
            },
            {
              name: "Kanion Waimea",
              url:
                "https://www.hawaje.com.pl/kauai-park-przyrody-kanion-waimea-state-park.xml"
            },
            {
              name: "Kaui",
              url: "https://www.hawaje.com.pl/wyspa-kauai.xml"
            },
            {
              name: "Maui",
              url: "https://www.hawaje.com.pl/wyspa-maui.xml"
            }
          ],
          Atrakcje: [
            {
              name: "surfing",
              url: ""
            },
            {
              name: "windsurfing & kite",
              url: ""
            },
            {
              name: "nurkowanie",
              url: ""
            },
            {
              name: "rowery górskie",
              url: ""
            },
            {
              name: "golf",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Hiszpania",
            urlgeo: "/hiszpania.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "hiszpania",
            grupa: "1",
            url: "https://www.hiszpania.com.pl",
            photo: "ES-01.jpg",
            cenamin: "37"
          },
          Opis:
            "Barcelona Gaudiego, gorące plaże Costa del Sol, namiętne rytmy flamenco i hiszpański temperament, soczysta i słodka sangría oraz pyszne jedzenie – Hiszpania, kraj kontrastów, od lat fascynuje i zachwyca swą kulturą, tradycją, zabytkami oraz pięknym i popularnym wybrzeżem!",
          Polecamy: [
            {
              name: "Alhambra",
              url: ""
            },
            {
              name: "Granada",
              url: "https://www.hiszpania.com.pl/granada.xml"
            },
            {
              name: "Madryt",
              url: "https://www.hiszpania.com.pl/madryt.xml"
            },
            {
              name: "Sevilla",
              url: "https://www.hiszpania.com.pl/sewilla.xml"
            },
            {
              name: "Kordoba",
              url: "https://www.hiszpania.com.pl/kordoba.xml"
            },
            {
              name: "Girona - muzeum Dalego",
              url: "https://www.hiszpania.com.pl/girona.xml"
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne",
              url:
                "https://www.hiszpania.com.pl/rodzaj-oferty/sporty-wodne-w-hiszpanii.xml"
            },
            {
              name: "trekking w górach",
              url: ""
            },
            {
              name: "windsurfing i kitesurfing",
              url:
                "https://www.hiszpania.com.pl/rodzaj-oferty/kite-windsurfing-w-hiszpanii.xml"
            },
            {
              name: "city breaks",
              url:
                "https://www.hiszpania.com.pl/rodzaj-oferty/city-breaks-w-hiszpanii.xml"
            },
            {
              name: "zwiedzanie",
              url:
                "https://www.hiszpania.com.pl/rodzaj-oferty/wycieczki-objazdowe-po-hiszpanii.xml"
            },
            {
              name: "wypoczynek i zwiedzanie",
              url:
                "https://www.hiszpania.com.pl/rodzaj-oferty/wycieczki-objazdowo-pobytowe-w-hiszpanii.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Irlandia",
            urlgeo: "/irlandia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "irlandia",
            grupa: "1",
            url: "https://www.irlandia.info.pl",
            photo: "IE-01.jpg",
            cenamin: "4031"
          },
          Opis:
            "Zielona Wyspa to kraina wzgórz, legend, piwa oraz św. Patryka i U2! Do głównych atrakcji Irlandii należą historyczne miasta Dublin i Cork, wyspy Aran oraz Liscannorna z klifowym wybrzeżem i zatoką. Region słynie także z ciekawych sportów narodowych: hurlingu i futbolu gaelickiego. Irlandia jest popularnym celem wyjazdów weekendowych.",
          Polecamy: [
            {
              name: "Dublin",
              url: "https://www.irlandia.info.pl/dublin.xml"
            },
            {
              name: "Cork",
              url: "https://www.irlandia.info.pl/cork.xml"
            },
            {
              name: "Wyspy Aran",
              url: "https://www.irlandia.info.pl/wyspy-aran.xml"
            },
            {
              name: "wieś Blarney",
              url: ""
            },
            {
              name: "średniowieczne zamki",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "turystyka krajoznawcza",
              url: "https://www.irlandia.info.pl/oferta/szukaj.xml"
            },
            {
              name: "górskie wędrówki",
              url: ""
            },
            {
              name: "city breaks",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Karaiby",
            urlgeo: "/karaiby.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "karaiby",
            grupa: "9",
            url: "https://www.karaiby.pl",
            photo: "KR-01.jpg",
            cenamin: "979"
          },
          Opis:
            "Słońce, rajskie plaże i morze, palmy, rum i piraci! Karaiby to synonim egzotycznych wakacji. Jamajka Boba Marley’a, Kuba Fidela Castro, znana z „Błękitnej Laguny” Dominikana to najpopularniejsze karaibskie wyspy. Idealne miejsce dla miłośników przyrody, historii i sportów wodnych.",
          Polecamy: [
            {
              name: "Dominikana",
              url: "https://www.karaiby.pl/dominikana.xml"
            },
            {
              name: "Jamajka",
              url: "https://www.karaiby.pl/jamajka.xml"
            },
            {
              name: "Kuba",
              url: "https://www.karaiby.pl/kuba.xml"
            },
            {
              name: "Varadero",
              url: "https://www.karaiby.pl/kuba-varadero.xml"
            },
            {
              name: "Antyle",
              url: "https://www.karaiby.pl/male-antyle.xml"
            },
            {
              name: "Punta Cana",
              url: "https://www.karaiby.pl/dominikana-punta-cana.xml"
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne",
              url: "https://www.karaiby.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "żeglowanie",
              url: "https://www.karaiby.pl/rodzaj-oferty/zeglarstwo.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.karaiby.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "windsurfing i kitesurfing",
              url:
                "https://www.karaiby.pl/rodzaj-oferty/windsurfing-kitesurfing.xml"
            },
            {
              name: "zwiedzanie",
              url:
                "https://www.karaiby.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "egzotyczne kurorty nadmorskie",
              url: "https://www.karaiby.pl/rodzaj-oferty/kurorty-nadmorskie.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Kanada",
            urlgeo: "/kanada.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "kanada",
            grupa: "11",
            url: "https://www.kanada.pl",
            photo: "CA-01.jpg",
            cenamin: "6012"
          },
          Opis:
            "Kraj Wielkich Jezior, prerii, dziewiczych lasów oraz syropu klonowego. To tu znajduje się słynny wodospad Niagara (na granicy z USA). Zabytki Ottawy, Quebeku, Toronto, kolonialna architektura Prowincji Wschodnich oraz tradycje rodzimych Indian przyciągają turystów zainteresowanych wielokulturowością Kanady.",
          Polecamy: [
            {
              name: "Ottawa",
              url: "https://www.kanada.pl/ottawa.xml"
            },
            {
              name: "Quebec",
              url: "https://www.kanada.pl/quebec-miasto.xml"
            },
            {
              name: "Toronto",
              url: "https://www.kanada.pl/toronto.xml"
            },
            {
              name: "Wyspa Księcia Edwarda",
              url: "https://www.kanada.pl/wyspa-ksiecia-edwarda.xml"
            },
            {
              name: "Nunavut",
              url: "https://www.kanada.pl/nunavut.xml"
            },
            {
              name: "Wielkie Jeziora w stanie Ontario",
              url: "https://www.kanada.pl/ontario.xml"
            },
            {
              name: "Wodospad Niagara",
              url: "https://www.kanada.pl/wodospad-niagara.xml"
            }
          ],
          Atrakcje: [
            {
              name: "trekking",
              url: ""
            },
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "wędrówki po prerii i terenach autochtonicznych",
              url: ""
            },
            {
              name: "objazdy i zwiedzanie",
              url: "https://www.kanada.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Kenia",
            urlgeo: "/kenia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "kenia",
            grupa: "7",
            url: "https://www.kenia.info.pl",
            photo: "KE-01.jpg",
            cenamin: "4271"
          },
          Opis:
            "Różnorodność krajobrazu i przyrody Kenii zadziwia i intryguje. Rezerwaty i parki narodowe Tsavo, Mt. Kenia oraz Amboseli u stóp Kilimandżaro to najczęściej odwiedzane miejsca w kraju. Jedź na safari, poznaj kulturę Suahili, zobacz rafę barierową, podziwiaj bezkresny błękit oceanu i nurkuj w ciepłych lagunach na wybrzeżu Oceanu Indyjskiego!",
          Polecamy: [
            {
              name: "wioski masajskie",
              url: ""
            },
            {
              name: "starówka Mombasy",
              url: "https://www.kenia.info.pl/mombasa.xml"
            },
            {
              name: "Wyspa Lamu",
              url: "https://www.kenia.info.pl/polnocne-wybrzeze-lamu.xml"
            },
            {
              name: "plaże Diani",
              url: "https://www.kenia.info.pl/diani-beach.xml"
            }
          ],
          Atrakcje: [
            {
              name: "safari",
              url: "https://www.kenia.info.pl/rodzaj-oferty/safari-w-kenii.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.kenia.info.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie-w-kenii.xml"
            },
            {
              name: "snorkeling na rafie koralowej",
              url: ""
            },
            {
              name: "wyprawy",
              url:
                "https://www.kenia.info.pl/rodzaj-oferty/wyprawy-po-kenii.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.kenia.info.pl/rodzaj-oferty/wycieczki-objazdowe-po-kenii.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Majorka",
            urlgeo: "/majorka.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "majorka",
            grupa: "1",
            url: "https://www.majorka.com.pl",
            photo: "BA-01.jpg",
            cenamin: "59"
          },
          Opis:
            "Baleary – raj dla miłośników wyspiarskiej atmosfery i zabawy. Szalone imprezy na Ibizie, piaszczyste plaże Majorki, kameralny relaks na Minorce, kosmopolityczna Palma – to najsłynniejsze miejsca Balearów. Bogactwo przyrody oraz kulturowa spuścizna sprawiają, że Baleary są dobrym wyborem zarówno na wypoczynek, jak i na zabawę!",
          Polecamy: [
            {
              name: "jaskinie Drach",
              url: "https://www.majorka.com.pl/jaskinie-coves-del-drach.xml"
            },
            {
              name: "Zamek d’Alaro",
              url: "https://www.majorka.com.pl/alaro.xml"
            },
            {
              name: "Palma",
              url: "https://www.majorka.com.pl/palma.xml"
            },
            {
              name: "Valldemossa",
              url: "https://www.majorka.com.pl/valldemossa.xml"
            },
            {
              name: "Soller",
              url: "https://www.majorka.com.pl/soller.xml"
            }
          ],
          Atrakcje: [
            {
              name: "trasy rowerowe",
              url: ""
            },
            {
              name: "sporty wodne",
              url:
                "https://www.majorka.com.pl/rodzaj-oferty/sporty-wodne-na-majorce.xml"
            },
            {
              name: "żeglarstwo",
              url:
                "https://www.majorka.com.pl/rodzaj-oferty/zeglarstwo-na-majorce.xml"
            },
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "życie nocne",
              url:
                "https://www.majorka.com.pl/rodzaj-oferty/zycie-nocne-na-majorce.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Malediwy",
            urlgeo: "/malediwy.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "malediwy",
            grupa: "3",
            url: "https://www.malediwy.com.pl",
            photo: "MD-01.jpg",
            cenamin: "2839"
          },
          Opis:
            "Archipelag na Oceanie Indyjskim, składający się z ponad tysiąca kameralnych wysepek, koralowych atoli z płytkimi, turkusowymi lagunami, białymi plażami i palmami kokosowymi. Malediwy to także liczne zabytki, orientalna kultura oraz smaczna lokalna kuchnia. Rajskie wakacje, luksusowe warunki i wiele atrakcji.",
          Polecamy: [
            {
              name: "Atol Male",
              url: "https://www.malediwy.com.pl/kaafu-atol.xml"
            },
            {
              name: "luksusowe chatki na palach",
              url: ""
            },
            {
              name: "niezwykły podwodny świat",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "nurkowanie",
              url:
                "https://www.malediwy.com.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "windsurfing",
              url:
                "https://www.malediwy.com.pl/rodzaj-oferty/windsurfing-kitesurfing.xml"
            },
            {
              name: "żeglarstwo",
              url: "https://www.malediwy.com.pl/rodzaj-oferty/zeglarstwo.xml"
            },
            {
              name: "pływanie w lagunach",
              url: "https://www.malediwy.com.pl/rodzaj-oferty/sporty-wodne.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Malezja",
            urlgeo: "/malezja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "malezja",
            grupa: "4",
            url: "https://www.malezja.info.pl",
            photo: "MY-01.jpg",
            cenamin: "3999"
          },
          Opis:
            "Azjatycki kraj pełen kontrastów – góry i nadmorskie niziny, tropikalna dżungla na Borneo, plaże na Langkawi, nowoczesne wieżowce i targowiska w Kuala Lumpur, magiczne świątynie, zabytki kolonialne oraz ogrody Lake Garden. Malakka i Singapur to najsłynniejsze miasta Malezji.",
          Polecamy: [
            {
              name: "Malakka",
              url: "https://www.malezja.info.pl/region-malacca.xml"
            },
            {
              name: "Wyspa Langkawi",
              url: "https://www.malezja.info.pl/wyspa-langkawi.xml"
            },
            {
              name: "Park Narodowy Taman Negara",
              url: "https://www.malezja.info.pl/wschodnie-wybrzeze.xml"
            }
          ],
          Atrakcje: [
            {
              name: "nurkowanie",
              url:
                "https://www.malezja.info.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "golf",
              url:
                "https://www.malezja.info.pl/rodzaj-oferty/pole-golfowe-blisko-hotelu.xml"
            },
            {
              name: "plażowanie na wyspach Langkawi i Borneo",
              url:
                "https://www.malezja.info.pl/rodzaj-oferty/hotele-blisko-plazy.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Malta",
            urlgeo: "/malta.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "malta-gozo",
            grupa: "1",
            url: "https://www.malta-gozo.pl",
            photo: "MG-01.jpg",
            cenamin: "359"
          },
          Opis:
            "Kraj barwnych festiwali, licznych imprez kulturalnych i bogatej historii. Oprócz ciekawych skalistych krajobrazów warte zobaczenia są tu megalityczne świątynie, średniowieczne budowle Zakonu Krzyża Maltańskiego oraz liczne muzea. Na Malcie panują świetne warunki do nurkowania.",
          Polecamy: [
            {
              name: "warowna Valletta",
              url: "https://www.malta-gozo.pl/malta-valletta.xml"
            },
            {
              name: "dawna siedziba Zakonu Rycerzy Maltańskich",
              url: "https://www.malta-gozo.pl/malta-three-cities-cottonera.xml"
            }
          ],
          Atrakcje: [
            {
              name: "nurkowanie",
              url:
                "https://www.malta-gozo.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "sporty wodne",
              url: "https://www.malta-gozo.pl/rodzaj-oferty/sporty-wodne.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Maroko",
            urlgeo: "/maroko.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "maroko",
            grupa: "6",
            url: "https://www.maroko.com.pl",
            photo: "MA-01.jpg",
            cenamin: "699"
          },
          Opis:
            "Królewskie miasta ze średniowiecznymi arcydziełami architektury, jak Marrakesz czy Fez, zielone oazy i wspaniałe plaże, ośnieżone szczyty gór Atlas i piaski Sahary. Orientalna atmosfera miesza się tutaj z europejskimi trendami. Casablanka oraz „wietrzne miasto” As-Sawira cieszą się wśród turystów niesłabnącą popularnością.",
          Polecamy: [
            {
              name: "tradycyjne bazary",
              url: ""
            },
            {
              name: "Casablanca",
              url: "https://www.maroko.com.pl/region-casablanca.xml"
            },
            {
              name: "Marrakesz",
              url: "https://www.maroko.com.pl/marakesz.xml"
            },
            {
              name: "meczet Hassana II w Casablance",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "wyprawy na Saharę",
              url: ""
            },
            {
              name: "sporty wodne",
              url: "https://www.maroko.com.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "trekking w górach",
              url: ""
            },
            {
              name: "luksusowe wczasy",
              url:
                "https://www.maroko.com.pl/rodzaj-oferty/luksusowe-wczasy.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.maroko.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Mauritius",
            urlgeo: "/wyspa-mauritius.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "mauritius",
            grupa: "8",
            url: "https://www.mauritius.pl",
            photo: "MU-01.jpg",
            cenamin: "2419"
          },
          Opis:
            "Kraj ptaka Dodo i wodospadów. Niezapomniana sceneria egzotycznych krajobrazów - wspaniałe plaże, przepiękne laguny, rafy koralowe, endemiczne gatunki roślin i zwierząt oraz plantacje trzciny cukrowej. Ogród Botaniczny w Pamplemousses, wodospad Rochester oraz Grand Baie to najpopularniejsze atrakcje Mauritiusa.",
          Polecamy: [
            {
              name: "Port Louis",
              url: "https://www.mauritius.pl/port-louis.xml"
            },
            {
              name: "Grand Baie",
              url: "https://www.mauritius.pl/grand-baie.xml"
            },
            {
              name: "luksusowe hotele",
              url: ""
            },
            {
              name: "ośrodki SPA",
              url: ""
            },
            {
              name: "piękne piaszczyste plaże i laguny",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "nurkowanie",
              url:
                "https://www.mauritius.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "windsurfing",
              url:
                "https://www.mauritius.pl/rodzaj-oferty/windsurfing-kitesurfing.xml"
            },
            {
              name: "wędkarstwo na pełnym morzu",
              url: ""
            },
            {
              name: "golf",
              url:
                "https://www.mauritius.pl/rodzaj-oferty/pole-golfowe-blisko-hotelu.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Meksyk",
            urlgeo: "/meksyk.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "meksyk",
            grupa: "9",
            url: "https://www.meksyk.com.pl",
            photo: "MX-01.jpg",
            cenamin: "3434"
          },
          Opis:
            "Kolorowy kraj tequili! Zabytkowe świątynie Majów i Azteków, metropolia Mexico City, indiańskie bazary, kolonialna architektura, Fiesta Mexicana, rafy koralowe i tropikalna dżungla – to tylko niektóre atrakcje Meksyku. Pikantna kuchnia meksykańska należy do najsmaczniejszych na świecie.",
          Polecamy: [
            {
              name: "miasto Meksyk",
              url: "https://www.meksyk.com.pl/mexico-city.xml"
            },
            {
              name: "Cancun",
              url: "https://www.meksyk.com.pl/cancun.xml"
            },
            {
              name: "Acapulco",
              url: "https://www.meksyk.com.pl/acapulco.xml"
            },
            {
              name: "wioski indiańskie",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "nurkowanie",
              url:
                "https://www.meksyk.com.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "sporty wodne na wybrzeżu",
              url: "https://www.meksyk.com.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "trekking w górach",
              url: ""
            },
            {
              name: "objazdówki",
              url: "https://www.meksyk.com.pl/oferta/szukaj.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Polinezja Francuska",
            urlgeo: "/polinezja-francuska.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "polinezja",
            grupa: "5",
            url: "https://www.polinezja.pl",
            photo: "PO-01.jpg",
            cenamin: "13399"
          },
          Opis:
            "Kraj czarnych pereł, boga Tiki, wodospadów, koralowych atoli, wulkanicznych wysp i krystalicznie czystej, turkusowej wody. Górzyste Thaiti lub Bora-Bora cieszą się największą popularnością. Idealne miejsca na egzotyczny wypoczynek nad bezkresem oceanu. Świetne warunki do nurkowania.",
          Polecamy: [
            {
              name: "Bora Bora",
              url: "https://www.polinezja.pl/bora-bora.xml"
            },
            {
              name: "Moorea",
              url: "https://www.polinezja.pl/moorea.xml"
            },
            {
              name: "Tahiti",
              url: "https://www.polinezja.pl/tahiti.xml"
            },
            {
              name: "Papeete",
              url: "https://www.polinezja.pl/papeete.xml"
            },
            {
              name: "Wyspy Towarzystwa",
              url: "https://www.polinezja.pl/wyspy-towarzystwa.xml"
            }
          ],
          Atrakcje: [
            {
              name: "nurkowanie",
              url:
                "https://www.polinezja.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "żeglowanie między wyspami",
              url: "https://www.polinezja.pl/rodzaj-oferty/zeglarstwo.xml"
            },
            {
              name: "sporty wodne",
              url: "https://www.polinezja.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "plażowanie",
              url:
                "https://www.polinezja.pl/rodzaj-oferty/hotele-blisko-plazy.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Portugalia",
            urlgeo: "/portugalia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "portugalia",
            grupa: "1",
            url: "https://www.portugalia.com.pl",
            photo: "PT-01.jpg",
            cenamin: "579"
          },
          Opis:
            "Kraj muzyki fado, sardynek i dorsza oraz romantycznej Lizbony. Malownicze, piaszczyste plaże Algarve, rozciągające się pod klifami są dumą Portugalczyków. Portugalia słynie z licznych festiwali reggae na wybrzeżu. Fatima, Madera, walki byków w Santarem oraz słynne winnice Porto – to tylko niektóre z atrakcji kraju.",
          Polecamy: [
            {
              name: "Lizbona",
              url: "https://www.portugalia.com.pl/lizbona.xml"
            },
            {
              name: "Porto",
              url: "https://www.portugalia.com.pl/porto.xml"
            },
            {
              name: "wyspa Madera",
              url: "https://www.portugalia.com.pl/wyspa-madera.xml"
            },
            {
              name: "Azory",
              url: "https://www.portugalia.com.pl/azory.xml"
            },
            {
              name: "Estoril",
              url: "https://www.portugalia.com.pl/estoril.xml"
            },
            {
              name: "Cabo da Roca",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne",
              url:
                "https://www.portugalia.com.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "trasy rowerowe",
              url: ""
            },
            {
              name: "trekking",
              url: ""
            },
            {
              name: "żeglowanie",
              url: "https://www.portugalia.com.pl/rodzaj-oferty/zeglarstwo.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.portugalia.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "życie nocne",
              url: "https://www.portugalia.com.pl/rodzaj-oferty/zycie-nocne.xml"
            },
            {
              name: "city breaks",
              url:
                "https://www.portugalia.com.pl/rodzaj-oferty/hotele-blisko-centrum.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Rosja",
            urlgeo: "/rosja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "rosja",
            grupa: "1",
            url: "https://www.rosja.pl",
            photo: "RU-01.jpg",
            cenamin: "1749"
          },
          Opis:
            "Największy kraj na świecie i serce Słowiańszczyzny. Bogata kultura i tradycja, historyczne miasta pełne przepychu. Kraj wódki, matrioszek, kolei transsyberyjskiej oraz białych nocy. Moskwa, Jekaterinburg, Sankt Petersburg to często odwiedzane przez turystów miasta. Najlepszym sposobem na zwiedzanie kraju są wycieczki objazdowe.",
          Polecamy: [
            {
              name: "Moskwa",
              url: "https://www.rosja.pl/moskwa.xml"
            },
            {
              name: "Sankt Petersburg",
              url: "https://www.rosja.pl/sankt-petersburg.xml"
            },
            {
              name: "Jekaterinburg",
              url: "https://www.rosja.pl/jekaterynburg.xml"
            },
            {
              name: "Obwód Kaliningradzki",
              url: "https://www.rosja.pl/obwod-kaliningradzki.xml"
            },
            {
              name: "kolej transsyberyjska",
              url: ""
            },
            {
              name: "Murmańsk",
              url: "https://www.rosja.pl/murmansk.xml"
            },
            {
              name: "Ural",
              url: "https://www.rosja.pl/okreg-uralski.xml"
            },
            {
              name: "Kamczatka",
              url: "https://www.rosja.pl/polwysep-kamczatka.xml"
            },
            {
              name: "Jezioro Bajkał",
              url: "https://www.rosja.pl/jezioro-bajkal.xml"
            }
          ],
          Atrakcje: [
            {
              name: "trekking",
              url: ""
            },
            {
              name: "tramping",
              url: ""
            },
            {
              name: "zwiedzanie miast i objazdówki",
              url: "https://www.rosja.pl/oferta/szukaj.xml"
            },
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "rejsy",
              url: ""
            },
            {
              name: "nurkowanie w Bajkale",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Republika Południowej Afryki",
            urlgeo: "/republika-poludniowej-afryki.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "rpa",
            grupa: "7",
            url: "https://www.rpa.pl",
            photo: "ZA-01.jpg",
            cenamin: "5299"
          },
          Opis:
            "Wielokulturowy kraj na południu Afryki. To tutaj znajduje się Lesotho, a także skrajny punkt Afryki – Przylądek Igielny. Dużą popularnością cieszą się wyprawy w Góry Smocze, na safari na Kalahari, wycieczki do Johannesburga i Kapsztadu, a także do kopalni diamentów w Kimberley!",
          Polecamy: [
            {
              name: "Johannesburg",
              url: "https://www.rpa.pl/johannesburg.xml"
            },
            {
              name: "Przylądek Igielny",
              url: ""
            },
            {
              name: "Przylądek Dobrej Nadziei",
              url: "https://www.rpa.pl/przyladek-dobrej-nadziei.xml"
            },
            {
              name: "Kapsztad",
              url: "https://www.rpa.pl/kapsztad.xml"
            },
            {
              name: "pustynia Kalahari",
              url: ""
            },
            {
              name: "Góry Smocze",
              url: "https://www.rpa.pl/gory-smocze.xml"
            },
            {
              name: "parki narodowe",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "trekking",
              url: ""
            },
            {
              name: "tramping",
              url: ""
            },
            {
              name: "safari",
              url: ""
            },
            {
              name: "objazdówki",
              url: "https://www.rpa.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Rumunia",
            urlgeo: "/rumunia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "rumunia",
            grupa: "1",
            url: "https://www.rumunia.info.pl",
            photo: "RO-01.jpg",
            cenamin: "921"
          },
          Opis:
            "Ojczyzna legendarnego księcia Draculi z Transylwanii. Różnorodny i kolorowy kraj niedrogich kurortów nad Morzem Czarnym oraz z wieloma historycznymi i ciekawymi miejscami, jak Bukareszt, Timisoara, Braszów, delta Dunaju. Coraz popularniejsze są wyjazdy narciarskie w rumuńskie Karpaty.",
          Polecamy: [
            {
              name: "malowane klasztory",
              url: "https://www.rumunia.info.pl/rumunia-polnocna.xml"
            },
            {
              name: "Sibiu (Sybin)",
              url: "https://www.rumunia.info.pl/sybin.xml"
            },
            {
              name: "Sighishoara",
              url: "https://www.rumunia.info.pl/sighisoara.xml"
            },
            {
              name: "zamek Hunedoara w Siedmiogrodzie",
              url: "https://www.rumunia.info.pl/transylwania-siedmiogrod.xml"
            }
          ],
          Atrakcje: [
            {
              name: "trekking",
              url: ""
            },
            {
              name: "wyprawy przez górskie trasy Karpat",
              url: ""
            },
            {
              name: "aktywne wakacje",
              url: "https://www.rumunia.info.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "kurorty nadmorskie",
              url:
                "https://www.rumunia.info.pl/rodzaj-oferty/kurorty-nadmorskie.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.rumunia.info.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Seszele",
            urlgeo: "/seszele.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "seszele",
            grupa: "7",
            url: "https://www.seszele.com.pl",
            photo: "SC-01.jpg",
            cenamin: "5161"
          },
          Opis:
            "Rajskie plaże otoczone soczyście zieloną roślinnością, z kameralnymi zatokami i turkusowym morzem. Do największych atrakcji tego wyspiarskiego kraju należą: rezerwat Valee de Mai oraz stolica – Victoria. Panują tu świetne warunki do surfingu oraz nurkowania!",
          Polecamy: [
            {
              name: "wyspa La Digue z 'Piratów' Polańskiego",
              url: "https://www.seszele.com.pl/wyspa-la-digue.xml"
            },
            {
              name: "wyspa Praslin",
              url: "https://www.seszele.com.pl/wyspa-praslin.xml"
            },
            {
              name: "wyspa Mahe",
              url: "https://www.seszele.com.pl/wyspa-mahe.xml"
            }
          ],
          Atrakcje: [
            {
              name: "nurkowanie",
              url:
                "https://www.seszele.com.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "windsurfing",
              url:
                "https://www.seszele.com.pl/rodzaj-oferty/windsurfing-kitesurfing.xml"
            },
            {
              name: "rejsy po wysepkach",
              url: "https://www.seszele.com.pl/rodzaj-oferty/zeglarstwo.xml"
            },
            {
              name: "plażowanie",
              url:
                "https://www.seszele.com.pl/rodzaj-oferty/hotele-blisko-plazy.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Słowacja",
            urlgeo: "/oferta/szukaj.xml?extern=1&sort=0",
            urlof: "/slowacja.xml",
            id: "slowacja",
            grupa: "1",
            url: "https://www.slowacja.com.pl",
            photo: "SK-01.jpg",
            cenamin: "100"
          },
          Opis:
            "Ośnieżone szczyty Tatr, Słowacki Raj, Spisz, warowne zamki, malownicze jeziora, tajemnicze jaskinie, parki wodne oraz uzdrowiska z basenami termalnymi. Słowacja to bogaty kulturowo i przyrodniczo kraj ze świetnymi warunkami do uprawiania sportów oraz znakomitą infrastrukturą narciarską. Blisko i tanio!",
          Polecamy: [
            {
              name: "Aquapark Tatralandia",
              url: ""
            },
            {
              name: "Chopok",
              url: "https://www.slowacja.com.pl/chopok.xml"
            },
            {
              name: "Strbskie Pleso",
              url: "https://www.slowacja.com.pl/strbske-pleso.xml"
            }
          ],
          Atrakcje: [
            {
              name: "turystyka piesza i rowerowa",
              url: ""
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.slowacja.com.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "narty",
              url:
                "https://www.slowacja.com.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "zwiedzanie jaskiń",
              url: ""
            },
            {
              name: "city breaks",
              url: ""
            },
            {
              name: "na weekend",
              url:
                "https://www.slowacja.com.pl/rodzaj-oferty/wyjazdy-weekendowe.xml"
            },
            {
              name: "nordic walking",
              url:
                "https://www.slowacja.com.pl/rodzaj-oferty/nordic-walking.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Słowenia",
            urlgeo: "/slowenia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "slowenia",
            grupa: "1",
            url: "https://www.slowenia.info.pl",
            photo: "SI-01.jpg",
            cenamin: "173"
          },
          Opis:
            "Maleńki i bardzo różnorodny kraj – włoskie miasteczka na wybrzeżu, romantyczna Lublana, malownicze krajobrazy, jeziora, niziny, kras i Alpy Julijskie. Do tego znakomite warunki do uprawiania sportów ekstremalnych oraz wysoki standard hoteli i luksusowe ośrodki SPA.",
          Polecamy: [
            {
              name: "Piran",
              url: "https://www.slowenia.info.pl/piran.xml"
            },
            {
              name: "Portorož",
              url: "https://www.slowenia.info.pl/portoroz.xml"
            },
            {
              name: "jaskinia w Postojnej",
              url: "https://www.slowenia.info.pl/jaskinia-postojna.xml"
            },
            {
              name: "Bohinj",
              url: "https://www.slowenia.info.pl/bohinj.xml"
            },
            {
              name: "Bled",
              url: "https://www.slowenia.info.pl/bled.xml"
            },
            {
              name: "Planica w Alpach",
              url: "https://www.slowenia.info.pl/planica.xml"
            }
          ],
          Atrakcje: [
            {
              name: "narty",
              url:
                "https://www.slowenia.info.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.slowenia.info.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "trekking",
              url: ""
            },
            {
              name: "mountainbike",
              url: ""
            },
            {
              name: "kajaki",
              url: ""
            },
            {
              name: "paralotnie",
              url: ""
            },
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "życie nocne",
              url: ""
            },
            {
              name: "objazdówki",
              url: ""
            },
            {
              name: "city breaks",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Sri Lanka",
            urlgeo: "/sri-lanka.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "srilanka",
            grupa: "3",
            url: "https://www.srilanka.com.pl",
            photo: "SL-01.jpg",
            cenamin: "1029"
          },
          Opis:
            "Kraj słoni, soczystej zieleni i pól herbacianych na wyspie Cejlon, nazywanej „łzą Indii”. Sri Lanka słynie nie tylko ze złocistych plaż nad oceanem, lecz także z gościnności mieszkańców, ich kultury oraz buddyjskich świątyń. Dla turystów ciekawych świata i szukających nowych, egzotycznych wrażeń!",
          Polecamy: [
            {
              name: "zabiegi ajurwedyjskie",
              url: ""
            },
            {
              name: "sierociniec dla słoni w Pinnawela",
              url: ""
            },
            {
              name: "Anuradhapura",
              url: "https://www.srilanka.com.pl/anuradhapura.xml"
            },
            {
              name: "Sigiriya",
              url: "https://www.srilanka.com.pl/sigiriya.xml"
            },
            {
              name: "Dambulla",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "nurkowanie",
              url:
                "https://www.srilanka.com.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "sporty wodne",
              url: "https://www.srilanka.com.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "jeep safari",
              url: ""
            },
            {
              name: "wycieczki na Malediwy",
              url: ""
            },
            {
              name: "objazdówki",
              url: "https://www.srilanka.com.pl/oferta/szukaj.xml"
            },
            {
              name: "żeglarstwo",
              url: "https://www.srilanka.com.pl/rodzaj-oferty/zeglarstwo.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Tajlandia",
            urlgeo: "/tajlandia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "tajlandia",
            grupa: "4",
            url: "https://www.tajlandia.com.pl",
            photo: "TH-01.jpg",
            cenamin: "3379"
          },
          Opis:
            "Kraj uśmiechniętych ludzi, kolorowych świąt i ciekawych obrzędów religijnych. Piękne, otoczone skałami, piaszczyste plaże, znane z filmów o Bondzie, złote buddyjskie świątynie oraz szaleństwo zakupów i zabawy w Bangkoku – to tylko niektóre atrakcje Tajlandii. Znakomita infrastruktura do uprawianie sportów wodnych.",
          Polecamy: [
            {
              name: "Phuket",
              url: "https://www.tajlandia.com.pl/region-phuket.xml"
            },
            {
              name: "Pattaya",
              url: "https://www.tajlandia.com.pl/pattaya.xml"
            },
            {
              name: "Phi Phi Don",
              url: "https://www.tajlandia.com.pl/ko-phi-phi-don.xml"
            },
            {
              name: "Krabi",
              url: "https://www.tajlandia.com.pl/krabi.xml"
            },
            {
              name: "Samui",
              url: "https://www.tajlandia.com.pl/ko-samui.xml"
            },
            {
              name: "Cha-Am",
              url: "https://www.tajlandia.com.pl/cha-am.xml"
            },
            {
              name: "tajską kuchnię",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "nurkowanie, kajaki, rejsy, SPA, wycieczki na słoniach, golf",
              url: ""
            },
            {
              name: "objazdówki",
              url:
                "https://www.tajlandia.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Tanzania",
            urlgeo: "/tanzania.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "tanzania",
            grupa: "7",
            url: "https://www.tanzania.pl",
            photo: "TZ-01.jpg",
            cenamin: "1299"
          },
          Opis:
            "Państwo afrykańskie, słynące z rezerwatów przyrody, parków narodowych i najwyższej góry na kontynencie – Kilimandżaro. Do największych atrakcji Tanzanii należą: Arusha, Dodoma i Zanzibar (wyspa przypraw z pięknymi plażami i zabytkowym miastem kultury Suahili). Kraj popularny na wyprawy oraz wśród amatorów safari.",
          Polecamy: [
            {
              name: "Serengeti",
              url: "https://www.tanzania.pl/park-narodowy-serengeti.xml"
            },
            {
              name: "Ngorongoro",
              url: "https://www.tanzania.pl/rezerwat-ngorongoro.xml"
            },
            {
              name: "Tanganika",
              url: "https://www.tanzania.pl/jezioro-tanganika.xml"
            },
            {
              name: "Zanzibar Stone Town",
              url: "https://www.tanzania.pl/stone-town-zanzibar.xml"
            }
          ],
          Atrakcje: [
            {
              name: "safari",
              url: "https://www.safari.tanzania.pl"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.tanzania.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie.xml"
            },
            {
              name: "trekking na Kilimandżaro",
              url: ""
            },
            {
              name: "objazdówki",
              url: "https://www.tanzania.pl/oferta/szukaj.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Tunezja",
            urlgeo: "/tunezja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "tunezja",
            grupa: "6",
            url: "https://www.tunezja.com.pl",
            photo: "TN-01.jpg",
            cenamin: "799"
          },
          Opis:
            "Jedna z najpopularniejszych destynacji turystycznych. Egzotyka, piękne wybrzeże, dobre warunki na rodzinne wczasy, wysoki standard hoteli oraz orientalna kuchnia przyciągają turystów przez cały rok. Do najciekawszych miejsc w Tunezji należą Tunis i Kartagina. Popularnością się cieszą wyprawy na safari na Saharę oraz w góry Atlas.",
          Polecamy: [
            {
              name: "Tunis",
              url: "https://www.tunezja.com.pl/tunis.xml"
            },
            {
              name: "Kartagina",
              url: "https://www.tunezja.com.pl/kartagina.xml"
            },
            {
              name: "Sidi Bou Said",
              url: "https://www.tunezja.com.pl/sidi-bou-said.xml"
            },
            {
              name: "Sousse",
              url: "https://www.tunezja.com.pl/sousse.xml"
            },
            {
              name: "wyspa Djerba",
              url: "https://www.tunezja.com.pl/dzerba.xml"
            }
          ],
          Atrakcje: [
            {
              name: "jeep safari na pustyni",
              url: ""
            },
            {
              name: "sporty wodne",
              url:
                "https://www.tunezja.com.pl/rodzaj-oferty/sporty-wodne-w-tunezji.xml"
            },
            {
              name: "nurkowanie",
              url:
                "https://www.tunezja.com.pl/rodzaj-oferty/wyjazdy-nurkowe-nurkowanie-w-tunezji.xml"
            },
            {
              name: "zwiedzanie",
              url:
                "https://www.tunezja.com.pl/rodzaj-oferty/wycieczki-objazdowe-po-tunezji.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Turcja",
            urlgeo: "/turcja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "turcja",
            grupa: "1",
            url: "https://www.turcja.com.pl",
            photo: "TK-01.jpg",
            cenamin: "589"
          },
          Opis:
            "Pogranicze kontynentów i kultur, orientalno-bizantyjski Stambuł, antyczne zabytki, piaszczyste plaże Riwiery Tureckiej, górzyste Wybrzeże Egejskie, Kapadocja – Turcja przyciąga turystów licznymi atrakcjami i pięknymi krajobrazami. Jeden z najpopularniejszych krajów wakacyjnych. Wysoki standard hoteli.",
          Polecamy: [
            {
              name: "laguna Oludeniz",
              url: "https://www.turcja.com.pl/oludeniz.xml"
            },
            {
              name: "antyczny Efez",
              url: "https://www.turcja.com.pl/efez.xml"
            },
            {
              name: "Kapadocja",
              url: "https://www.turcja.com.pl/kapadocja.xml"
            },
            {
              name: "Marmaris",
              url: "https://www.turcja.com.pl/riwiera-marmaris.xml"
            },
            {
              name: "Alanya",
              url: "https://www.turcja.com.pl/riwiera-alanya.xml"
            }
          ],
          Atrakcje: [
            {
              name: "żeglowanie",
              url:
                "https://www.turcja.com.pl/rodzaj-oferty/zeglarstwo-w-turcji.xml"
            },
            {
              name: "golf",
              url:
                "https://www.turcja.com.pl/rodzaj-oferty/pole-golfowe-blisko-hotelu-w-turcji.xml"
            },
            {
              name: "sporty wodne",
              url:
                "https://www.turcja.com.pl/rodzaj-oferty/sporty-wodne-w-turcji.xml"
            },
            {
              name: "trekking górski",
              url: ""
            },
            {
              name: "rowery",
              url: ""
            },
            {
              name: "luksusowe wczasy",
              url:
                "https://www.turcja.com.pl/rodzaj-oferty/luksusowe-wczasy-w-turcji.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.turcja.com.pl/rodzaj-oferty/wycieczki-objazdowe-po-turcji.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Węgry",
            urlgeo: "/wegry.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "wegry",
            grupa: "1",
            url: "https://www.wegry.biz.pl",
            photo: "HU-01.jpg",
            cenamin: "73"
          },
          Opis:
            "Imponujący secesyjną architekturą Budapeszt i pagórkowaty krajobraz z winnicami, gorące źródła oraz Jezioro Balaton to idealny wybór na rodzinne, niedrogie wczasy. Bogata historia, smaczna kuchnia narodowa, wyborne wina – to tylko kilka powodów do odwiedzenia Węgier. Popularny kraj na wypady weekendowe!",
          Polecamy: [
            {
              name: "Heviz",
              url: "https://www.wegry.biz.pl/balaton-heviz.xml"
            },
            {
              name: "Hadusoboslo",
              url: "https://www.wegry.biz.pl/hajduszoboszlo.xml"
            },
            {
              name: "Eger",
              url: "https://www.wegry.biz.pl/eger.xml"
            },
            {
              name: "Budapeszt",
              url: "https://www.wegry.biz.pl/budapeszt.xml"
            },
            {
              name: "Keszthely",
              url: "https://www.wegry.biz.pl/balaton-keszthely.xml"
            },
            {
              name: "Tihany",
              url: "https://www.wegry.biz.pl/balaton-tihany.xml"
            }
          ],
          Atrakcje: [
            {
              name: "przejażdżki konne",
              url: ""
            },
            {
              name: "trasy rowerowe",
              url: ""
            },
            {
              name: "city breaks",
              url: "https://www.wegry.biz.pl/rodzaj-oferty/city-breaks.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.wegry.biz.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Wenezuela",
            urlgeo: "/wenezuela.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "wenezuela",
            grupa: "10",
            url: "https://www.wenezuela.info.pl",
            photo: "VE-01.jpg",
            cenamin: []
          },
          Opis:
            "Kraj różnorodności przyrodniczej oraz kulturowych ciekawostek – amazońska dżungla, Andy i szczyt Pico Bolivar, sawanna, wodospad Salto del Angel, Caracas, wenezuelscy kowboje. Wenezuela przyciąga dziką przyrodą oraz kolorową lokalną kulturą. Popularne miejsce na wyprawy i trampingi.",
          Polecamy: [
            {
              name: "Caracas",
              url: "https://www.wenezuela.info.pl/caracas-.xml"
            },
            {
              name: "Puerto La Cruz",
              url: "https://www.wenezuela.info.pl/puerto-la-cruz.xml"
            },
            {
              name: "Guayana",
              url: "https://www.wenezuela.info.pl/region-gujany.xml"
            },
            {
              name: "wodospad Salto del Angel",
              url: "https://www.wenezuela.info.pl/salto-angel.xml"
            },
            {
              name: "Park Narodowy Canaima",
              url: "https://www.wenezuela.info.pl/park-narodowy-canaima.xml"
            }
          ],
          Atrakcje: [
            {
              name: "tramping",
              url: ""
            },
            {
              name: "trekking",
              url: ""
            },
            {
              name: "wyprawy wysokogórskie",
              url: ""
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.wenezuela.info.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "sporty wodne",
              url:
                "https://www.wenezuela.info.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "rejsy",
              url: ""
            },
            {
              name: "objazdówki",
              url:
                "https://www.wenezuela.info.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "plażowanie",
              url:
                "https://www.wenezuela.info.pl/rodzaj-oferty/hotele-blisko-plazy.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Wielka Brytania",
            urlgeo: "/wielka-brytania.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "wielkabrytania",
            grupa: "1",
            url: "https://www.wielkabrytania.com.pl",
            photo: "GB-01.jpg",
            cenamin: "899"
          },
          Opis:
            "Piętrowe autobusy, czerwone budki telefoniczne i five o’clock to pierwsze skojarzenia z Anglią. Historyczny Londyn to popularne miejsce na wypady weekendowe i na zakupy, górzysta Walia, szkockie fiordy i Loch Ness to obowiązkowe punkty programów wycieczek objazdowych po Anglii.",
          Polecamy: [
            {
              name: "Londyn",
              url: "https://www.wielkabrytania.com.pl/londyn.xml"
            },
            {
              name: "Manchester",
              url: "https://www.wielkabrytania.com.pl/manchester.xml"
            },
            {
              name: "Birmingham",
              url: "https://www.wielkabrytania.com.pl/birmingham.xml"
            },
            {
              name: "szczyt Snowdon",
              url: "https://www.wielkabrytania.com.pl/snowdonia.xml"
            },
            {
              name: "Cardiff",
              url: "https://www.wielkabrytania.com.pl/cardiff.xml"
            },
            {
              name: "Hebrydy",
              url: "https://www.wielkabrytania.com.pl/hebrydy.xml"
            },
            {
              name: "Szetlandy",
              url: "https://www.wielkabrytania.com.pl/szetlandy.xml"
            },
            {
              name: "Belfast",
              url: "https://www.wielkabrytania.com.pl/belfast.xml"
            },
            {
              name: "Oxford",
              url: "https://www.wielkabrytania.com.pl/oxford.xml"
            },
            {
              name: "jeziora szkockie",
              url: ""
            },
            {
              name: "średniowieczne zamki",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "objazdówki",
              url: "https://www.wielkabrytania.com.pl/oferta/szukaj.xml"
            },
            {
              name: "zwiedzanie, wspinaczka, wędrówki, city breaks",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Włochy",
            urlgeo: "/wlochy.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "wlochy",
            grupa: "1",
            url: "https://www.wlochy.pl",
            photo: "IT-01.jpg",
            cenamin: "59"
          },
          Opis:
            "Poetycka Toskania, tajemniczy Watykan, historyczny Rzym i Neapol, Sycylia, śródziemnomorska kuchnia, lodowce w Dolomitach i skąpane w słońcu plaże Kalabrii. Bardzo zróżnicowana oferta turystyczna Włoch obejmuje zabytki i historyczne miejsca oraz kurorty nadmorskie i narciarskie.",
          Polecamy: [
            {
              name: "Rzym",
              url: "https://www.wlochy.pl/rzym.xml"
            },
            {
              name: "Wenecja",
              url: "https://www.wlochy.pl/wenecja.xml"
            },
            {
              name: "Watykan",
              url: "https://www.wlochy.pl/watykan.xml"
            },
            {
              name: "Amalfi",
              url: "https://www.wlochy.pl/wybrzeze-amalfi.xml"
            },
            {
              name: "Pompeje",
              url: "https://www.wlochy.pl/pompeje.xml"
            },
            {
              name: "Werona",
              url: "https://www.wlochy.pl/werona.xml"
            },
            {
              name: "włoska kuchnia",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "windsurfing",
              url:
                "https://www.wlochy.pl/rodzaj-oferty/kite-windsurfing-we-wloszech.xml"
            },
            {
              name: "rowery",
              url: ""
            },
            {
              name: "wspinaczka i trekking",
              url: ""
            },
            {
              name: "narty",
              url:
                "https://www.wlochy.pl/rodzaj-oferty/wyjazdy-na-narty-do-wloch.xml"
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.wlochy.pl/rodzaj-oferty/sport-we-wloszech.xml"
            },
            {
              name: "city breaks",
              url:
                "https://www.wlochy.pl/rodzaj-oferty/hotele-blisko-centrum-miejscowosci-we-wloszech.xml"
            },
            {
              name: "objazdówki",
              url:
                "https://www.wlochy.pl/rodzaj-oferty/wycieczki-objazdowe-po-wloszech.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Wyspy Kanaryjskie",
            urlgeo: "/kanary.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "wyspykanaryjskie",
            grupa: "6",
            url: "https://www.wyspykanaryjskie.pl",
            photo: "CI-01.jpg",
            cenamin: "50"
          },
          Opis:
            "Wyspy „wiecznej wiosny”. Zielona Gomera, księżycowe Lanzarote, kosmopolityczna Teneryfa i Gran Canaria to najpopularniejsze z rajskich wysp. Lokalny folklor i kultura rdzennych Guanczów są dodatkowymi atrakcjami regionu. Do najciekawszych miejsc należą: wydmy Maspalomas, krater wulkaniczny El Golfo, parki El Loro, Tejde i Garajonay.",
          Polecamy: [
            {
              name: "Maspalomas",
              url: "https://www.wyspykanaryjskie.pl/gran-canaria-maspalomas.xml"
            },
            {
              name: "Playa de las Americas",
              url:
                "https://www.wyspykanaryjskie.pl/teneryfa-playa-de-las-americas.xml"
            },
            {
              name: "Los Gigantes",
              url: "https://www.wyspykanaryjskie.pl/teneryfa-los-gigantes.xml"
            },
            {
              name: "Wulkan Teide",
              url:
                "https://www.wyspykanaryjskie.pl/teneryfa-park-narodowy-teide.xml"
            }
          ],
          Atrakcje: [
            {
              name: "kite i windsurfing",
              url:
                "https://www.wyspykanaryjskie.pl/rodzaj-oferty/kite-windsurfing-na-wyspach-kanaryjskich.xml"
            },
            {
              name: "jachting",
              url:
                "https://www.wyspykanaryjskie.pl/rodzaj-oferty/zeglarstwo-na-wyspach-kanaryjskich.xml"
            },
            {
              name: "trekking po wulkanach",
              url: ""
            },
            {
              name: "luksusowe wczasy",
              url:
                "https://www.wyspykanaryjskie.pl/rodzaj-oferty/luksusowe-wczasy-na-wyspach-kanaryjskich.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Wyspy Zielonego Przylądka",
            urlgeo: "/wyspy-zielonego-przyladka.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "wyspyzielonegoprzyladka",
            grupa: "6",
            url: "https://www.wyspyzielonegoprzyladka.pl",
            photo: "CV-01.jpg",
            cenamin: "2999"
          },
          Opis:
            "Kraj piosenkarki Cesarii Evory, bogatej lokalnej kultury i kolonialnej architektury. Niezwykle ciekawy i wciąż mało znany zakątek świata. Największą zaletą wysp jest różnorodny krajobraz i przyroda – góry, wulkany, surowy pustynny krajobraz oraz rajskie plaże. Luksusowe wakacje na Oceanie Atlantyckim.",
          Polecamy: [
            {
              name: "Praia",
              url: "https://www.wyspyzielonegoprzyladka.pl/praia.xml"
            },
            {
              name: "Mindelo",
              url: "https://www.wyspyzielonegoprzyladka.pl/mindelo.xml"
            },
            {
              name: "Santo Antao",
              url: "https://www.wyspyzielonegoprzyladka.pl/santo-antao.xml"
            },
            {
              name: "Fogo",
              url: "https://www.wyspyzielonegoprzyladka.pl/fogo.xml"
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne, rejsy, trampingi i trekkingi",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Izrael",
            urlgeo: "/izrael.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "izrael",
            grupa: "2",
            url: "https://www.izrael.pl",
            photo: "IZ-01.jpg",
            cenamin: "1890"
          },
          Opis:
            "Ziemia Święta dla Żydów, Chrześcijan i Muzułmanów. Izrael to z jednej strony bogata kultura, zabytki i odkrycia archeologiczne, a z drugiej – piękne wybrzeże, egzotyczne krajobrazy oraz skarby Morza Martwego. Kraj odwiedzany przez pielgrzymów, a także przez ludzi ciekawych świata i jego historii.",
          Polecamy: [
            {
              name: "Jerozolima",
              url: "https://www.izrael.pl/jerozolima.xml"
            },
            {
              name: "Betlejem",
              url: "https://www.izrael.pl/betlejem.xml"
            },
            {
              name: "Morze Martwe",
              url: "https://www.izrael.pl/morze-martwe.xml"
            },
            {
              name: "Ejlat nad Morzem Czerwonym",
              url: "https://www.izrael.pl/ejlat.xml"
            },
            {
              name: "Zatoka Akaba",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "turystyka religijna",
              url: ""
            },
            {
              name: "zwiedzanie",
              url: "https://www.izrael.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "safari",
              url: ""
            },
            {
              name: "egzotyka",
              url: ""
            },
            {
              name: "wakacje w SPA",
              url: "https://www.izrael.pl/rodzaj-oferty/wakacje-w-spa.xml"
            },
            {
              name: "sporty wodne",
              url: "https://www.izrael.pl/rodzaj-oferty/sporty-wodne.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Stany Zjednoczone",
            urlgeo: "/stany-zjednoczone.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "stanyzjednoczone",
            grupa: "11",
            url: "https://www.stanyzjednoczone.pl",
            photo: "US-01.jpg",
            cenamin: "4929"
          },
          Opis:
            "Stany Zjednoczone to państwo pełne skrajności i kontrastów, potęga gospodarcza i jeden z najciekawszych krajów na świecie. Statua Wolności, pomnik Lincolna, Wielki Kanion, Las Vegas, Hollywood, Teksas – Stany Zjednoczone to mieszanka kultur i narodów, krajobrazów i zjawisk, tradycji i nowoczesności.",
          Polecamy: [
            {
              name: "Nowy Jork",
              url: "https://www.stanyzjednoczone.pl/nowy-jork.xml"
            },
            {
              name: "Chicago",
              url: "https://www.stanyzjednoczone.pl/chicago.xml"
            },
            {
              name: "California",
              url: "https://www.stanyzjednoczone.pl/kalifornia-i-okolice.xml"
            },
            {
              name: "Waszyngton",
              url: "https://www.stanyzjednoczone.pl/waszyngton-dc.xml"
            },
            {
              name: "Wielki Kanion",
              url: "https://www.stanyzjednoczone.pl/wielki-kanion.xml"
            },
            {
              name: "Teksas",
              url: "https://www.stanyzjednoczone.pl/texas.xml"
            },
            {
              name: "Wodospad Niagara",
              url: "https://www.stanyzjednoczone.pl/niagara-falls-.xml"
            },
            {
              name: "Las Vegas",
              url: "https://www.stanyzjednoczone.pl/las-vegas.xml"
            }
          ],
          Atrakcje: [
            {
              name: "podróże autostopem",
              url: ""
            },
            {
              name: "zwiedzanie miast i zabytków",
              url:
                "https://www.stanyzjednoczone.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "sporty wodne",
              url: ""
            },
            {
              name: "tramping",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Szwajcaria",
            urlgeo: "/szwajcaria.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "szwajcaria",
            grupa: "1",
            url: "https://www.szwajcaria.com.pl",
            photo: "CH-01.jpg",
            cenamin: "268"
          },
          Opis:
            "„Dom gór” – Szwajcaria znana jest ze znakomitych warunków narciarskich. Słynie także z banków, zegarków, demokracji i neutralności. Wielokulturowa Szwajcaria to także tradycyjne miasteczka, historyczna zabudowa miast i zabytki do Berna, Bazylei, Zurychu, Lozanny czy Fryburgu. Lodowiec Matterhorn to popularne miejsce wśród narciarzy.",
          Polecamy: [
            {
              name: "Berno",
              url: "https://www.szwajcaria.com.pl/berno.xml"
            },
            {
              name: "Zurych",
              url: "https://www.szwajcaria.com.pl/zurych.xml"
            },
            {
              name: "Genewa",
              url: "https://www.szwajcaria.com.pl/genewa.xml"
            },
            {
              name: "Lozanna",
              url: "https://www.szwajcaria.com.pl/lozanna.xml"
            },
            {
              name: "Alpy",
              url: ""
            },
            {
              name: "lodowiec",
              url: ""
            },
            {
              name: "Jezioro Genewskie",
              url:
                "https://www.szwajcaria.com.pl/region-jeziora-genewskiego.xml"
            }
          ],
          Atrakcje: [
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "narciarstwo",
              url:
                "https://www.szwajcaria.com.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "zwiedzanie i objazdówki",
              url:
                "https://www.szwajcaria.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.szwajcaria.com.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "nordic walking",
              url:
                "https://www.szwajcaria.com.pl/rodzaj-oferty/nordic-walking.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Chiny",
            urlgeo: "/chinska-republika-ludowa.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "chiny",
            grupa: "4",
            url: "https://www.chiny.com.pl",
            photo: "CN-01.jpg",
            cenamin: "2799"
          },
          Opis:
            "Kraj Środka. Potęga gospodarcza i najstarsza cywilizacja na świecie. Wielki Mur Chiński, Terakotowa Armia z Xi’an, Pałac Cesarski w Pekinie to najbardziej znane atrakcje Chin. Turystów przyciągają także baśniowe krajobrazy, orientalna kultura oraz specjały lokalnej kuchni.",
          Polecamy: [
            {
              name: "Pekin",
              url: "https://www.chiny.com.pl/beijing-pekin.xml"
            },
            {
              name: "Hongkong",
              url: "https://www.chiny.com.pl/hong-kong-metropolia.xml"
            },
            {
              name: "Szanghaj",
              url: "https://www.chiny.com.pl/szanghaj.xml"
            },
            {
              name: "Tajwan",
              url: "https://www.chiny.com.pl/wyspa-tajwan.xml"
            },
            {
              name: "Jangcy",
              url: ""
            },
            {
              name: "Karakorum",
              url: ""
            },
            {
              name: "Himalaje",
              url: ""
            },
            {
              name: "Tybet",
              url: "https://www.chiny.com.pl/tybet.xml"
            },
            {
              name: "Terakotowa Armia w Xi'an",
              url: "https://www.chiny.com.pl/xian.xml"
            }
          ],
          Atrakcje: [
            {
              name: "objazdówki i zwiedzanie",
              url:
                "https://www.chiny.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name:
                "tramping, wspinaczka wysokogórska, podróże kulinarne, trekking",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Indie",
            urlgeo: "/indie.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "indie",
            grupa: "3",
            url: "https://www.indie.com.pl",
            photo: "IN-01.jpg",
            cenamin: "3249"
          },
          Opis:
            "Kraj kontrastów i skrajności. Prastara kultura, bogata historia i tradycja, ajurweda i hinduizm, wyśmienita kuchnia, liczne zabytki sakralne, nowoczesne miasta, bieda i bogactwo, piękne wybrzeże i wysoka technologia, mieszanka nacji, wysokie góry oraz tereny pustynne. Indie to miejsce dla pasjonatów i ludzi ciekawych świata!",
          Polecamy: [
            {
              name: "Agra",
              url: "https://www.indie.com.pl/agra.xml"
            },
            {
              name: "Taj Mahal",
              url: "https://www.indie.com.pl/taj-mahal.xml"
            },
            {
              name: "Bombaj",
              url: "https://www.indie.com.pl/bombaj-mumbai.xml"
            },
            {
              name: "Dźajpur",
              url: "https://www.indie.com.pl/dzajpur.xml"
            },
            {
              name: "Kalkuta",
              url: "https://www.indie.com.pl/kalkuta.xml"
            },
            {
              name: "Madras",
              url: "https://www.indie.com.pl/madras-chennai.xml"
            },
            {
              name: "Delhi",
              url: "https://www.indie.com.pl/delhi.xml"
            },
            {
              name: "New Delhi",
              url: "https://www.indie.com.pl/new-delhi.xml"
            }
          ],
          Atrakcje: [
            {
              name: "tramping",
              url: ""
            },
            {
              name: "trekking",
              url: ""
            },
            {
              name: "zwiedzanie miejsc kultu i zabytków",
              url:
                "https://www.indie.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "orientalne podróże",
              url: ""
            },
            {
              name: "sporty wodne",
              url: "https://www.indie.com.pl/rodzaj-oferty/sporty-wodne.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Jordania",
            urlgeo: "/jordania.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "jordania",
            grupa: "2",
            url: "https://www.jordania.info.pl",
            photo: "JO-01.jpg",
            cenamin: "1984"
          },
          Opis:
            "Egzotyczny kraj z wieloma atrakcjami – słone Morze Martwe, wulkaniczna pustynia Harra, biblijna góra Nebo, Jordan, Zatoka Akaby nad Morzem Czerwonym. Najsłynniejszym miejscem w Jordanii jest Petra, jeden z nowych cudów świata. „Europejski” Bliski Wschód otwarty na turystów!",
          Polecamy: [
            {
              name: "Petra",
              url: "https://www.jordania.info.pl/petra.xml"
            },
            {
              name: "Morze Martwe",
              url: "https://www.jordania.info.pl/morze-martwe.xml"
            },
            {
              name: "dolina Jordanu",
              url: ""
            },
            {
              name: "góra Nebo",
              url: "https://www.jordania.info.pl/gora-nebo.xml"
            },
            {
              name: "Amman",
              url: "https://www.jordania.info.pl/amman.xml"
            },
            {
              name: "Wadi Rum",
              url: "https://www.jordania.info.pl/dolina-wadi-rum.xml"
            },
            {
              name: "Madaba",
              url: "https://www.jordania.info.pl/madaba.xml"
            }
          ],
          Atrakcje: [
            {
              name: "trekkingi",
              url: ""
            },
            {
              name: "safari",
              url: ""
            },
            {
              name: "zwiedzanie zabytków",
              url:
                "https://www.jordania.info.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "turystyka religijna",
              url: ""
            },
            {
              name: "turystyka kulinarna",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Peru",
            urlgeo: "/peru.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "peru",
            grupa: "10",
            url: "https://www.peru.info.pl",
            photo: "PE-01.jpg",
            cenamin: "8400"
          },
          Opis:
            "Kraj nad Pacyfikiem, który zachwyca turystów pięknem krajobrazu i niewiarygodnymi panoramami Andów, tajemniczymi ruinami oraz wyjątkową lokalną kulturą. Amazońska Dżungla, Jezioro Titicaca, Machu Picchu, Region Cuzco, Nazca to najciekawsze peruwiańskie atrakcje.",
          Polecamy: [
            {
              name: "Lima",
              url: "https://www.peru.info.pl/lima.xml"
            },
            {
              name: "Nazca",
              url: "https://www.peru.info.pl/nazca.xml"
            },
            {
              name: "Machu Picchu",
              url: "https://www.peru.info.pl/machu-picchu.xml"
            },
            {
              name: "Cuzco",
              url: "https://www.peru.info.pl/cuzco.xml"
            },
            {
              name: "Andy",
              url: ""
            },
            {
              name: "Wybrzeże Pacyfiku",
              url: ""
            },
            {
              name: "lasy amazońskie",
              url: "https://www.peru.info.pl/dzungla-amazonska.xml"
            }
          ],
          Atrakcje: [
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "tramping",
              url: ""
            },
            {
              name: "trekking",
              url: ""
            },
            {
              name: "turystyka krajoznawcza",
              url: "https://www.peru.info.pl/oferta/szukaj.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Niemcy",
            urlgeo: "/niemcy.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "niemcy",
            grupa: "1",
            url: "https://www.niemcy.com.pl",
            photo: "DE-01.jpg",
            cenamin: "109"
          },
          Opis:
            "Kraj piwa i Oktoberfestu, zamków bawarskich oraz zabytkowych miast, takich jak Berlin i Monachium. Niemcy są dobrą propozycją na wyjazd o każdej porze roku – liczne górskie kurorty, ciekawe wybrzeże Morza Bałtyckiego i Północnego oraz bogata kultura i historia. Kraj popularny na wyjazdy weekendowe.",
          Polecamy: [
            {
              name: "Berlin",
              url: "https://www.niemcy.com.pl/berlin.xml"
            },
            {
              name: "Hamburg",
              url: "https://www.niemcy.com.pl/hamburg.xml"
            },
            {
              name: "Kolonia",
              url: "https://www.niemcy.com.pl/kolonia.xml"
            },
            {
              name: "Bonn",
              url: "https://www.niemcy.com.pl/bonn.xml"
            },
            {
              name: "Monachium",
              url: "https://www.niemcy.com.pl/monachium.xml"
            },
            {
              name: "Bawaria",
              url: "https://www.niemcy.com.pl/bawaria.xml"
            },
            {
              name: "Saksonia",
              url: "https://www.niemcy.com.pl/dolna-saksonia-brema.xml"
            },
            {
              name: "Szlezwik-Holsztyn",
              url: "https://www.niemcy.com.pl/szlezwik-holsztyn-hamburg.xml"
            },
            {
              name: "bawarskie zamki",
              url: ""
            },
            {
              name: "Oktoberfest",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "wycieczki objazdowe",
              url:
                "https://www.niemcy.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "city breaks",
              url: ""
            },
            {
              name: "narty",
              url:
                "https://www.niemcy.com.pl/rodzaj-oferty/kurorty-narciarskie.xml"
            },
            {
              name: "wyprawy górskie",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Dania",
            urlgeo: "/dania.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "dania",
            grupa: "1",
            url: "https://www.dania.info.pl",
            photo: "DK-01.jpg",
            cenamin: "379"
          },
          Opis:
            "Królestwo zrodzone z morza. Dania, choć niewielka, ma do zaoferowania więcej, niż by się mogło wydawać – Kopenhaga, zamki, wioski Wikingów, folklor Wysp Owczych, Legoland, malownicze krajobrazy, klify i plaże. Kraj baśni Andersena, Małej Syrenki, piwa Carlsberg, gangu Olsena oraz… ojczyzna Hamleta.",
          Polecamy: [
            {
              name: "Kopenhaga, Roskilde, Aalborg, Odense",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, nordic walking, city breaks, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Argentyna",
            urlgeo: "/argentyna.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "argentyna",
            grupa: "10",
            url: "https://www.argentyna.info.pl",
            photo: "AR-01.jpg",
            cenamin: "8599"
          },
          Opis:
            "Od Andów po nizinną pampę, od piaszczystych plaż po lodowce i szczyt Aconcagua, od rajskiego wodospadu Iquazu po boskie Buenos Aires. Argentyna przyciąga turystów egzotycznymi krajobrazami, barwnym folklorem oraz interesującą kulturą. Raj dla amatorów paralotni i windsurfingu. Egzotyczne wczasy od grudnia do marca!",
          Polecamy: [
            {
              name: "Buenos Aires, Cordoba, Rosario, Bahia Blanca, Mendoza",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, plażowanie, sporty wodne, rejsy, trekking, tramping, wyprawy, windsurfing, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Holandia",
            urlgeo: "/holandia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "holandia",
            grupa: "1",
            url: "https://www.holandia.info.pl",
            photo: "NL-01.jpg",
            cenamin: "229"
          },
          Opis:
            "Kupić kwiaty na pływającym targu Bloemenmarkt, zobaczyć dzieła van Gogha, odwiedzić coffee shop i słynny squat w Amsterdamie, zajrzeć do gwarnego portu w Rotterdamie, Południową Limburgię pokonać na rowerze. Holandia to kraj pełen skrajności – barwna kultura, piękne krajobrazy, gwarne miasta, niezwykłe miejsca i tolerancyjni ludzie.",
          Polecamy: [
            {
              name:
                "Amsterdam, Haga, Rotterdam, Groningen, Arnhem, Maastricht, Tilburg",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, nordic walking, city breaks, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Finlandia",
            urlgeo: "/finlandia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "finlandia",
            grupa: "1",
            url: "https://www.finlandia.info.pl",
            photo: "FL-01.jpg",
            cenamin: "1139"
          },
          Opis:
            "Z wizytą u Świętego Mikołaja i Muminków! Skocznia w Lahti, hokej w Hartwall Arena, helsińskie galerie i koncerty, wyścigi psich zaprzęgów w Laponii. Finlandia to kraj pełen atrakcji dla każdego – przekrocz koło podbiegunowe w Rovaniemi, zobacz zorzę polarną, skosztuj pysznego łososia i wypoczywaj na plaży w Kalojaki!",
          Polecamy: [
            {
              name:
                "Helsinki, Kuopio, Oulu, Rovaniemi, Turku, Levi, Rauma, Petajavesi",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, rejsy, trekking, tramping, wyprawy, wspinaczka, śnieżne safari",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Norwegia",
            urlgeo: "/norwegia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "norwegia",
            grupa: "1",
            url: "https://www.norwegia.info.pl",
            photo: "NO-01.jpg",
            cenamin: "1859"
          },
          Opis:
            "Kraj dla amatorów aktywnego wypoczynku, wypraw i natury. Norwegia to fiordy, strzeliste góry, wodospady, Nordkapp, lodowce, kolejka Bergen, Oslo, Park Olimpijski w Lillehammer, drewniane domy i Wikingowie. Wycieczki objazdowe to najlepszy sposób na zwiedzanie Norwegii.",
          Polecamy: [
            {
              name: "Oslo, Bergen, Trondheim, Tromso, Nordkapp",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, rejsy, trekking, tramping, wyprawy, wspinaczka, śnieżne safari",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Islandia",
            urlgeo: "/islandia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "islandia",
            grupa: "1",
            url: "https://www.islandia.info.pl",
            photo: "IS-01.jpg",
            cenamin: "2849"
          },
          Opis:
            "Nordycki kraj położony na wyspie, kojarzony głównie z Reykjavikiem, wulkanami, lodowcami, wodospadami i gejzerami. Przyroda jest największym atutem Islandii. Podczas zwiedzania kraju nie może zabraknąć też takich miejsc jak Hvalfjördur – Wielorybi Fiord, skamieniały smok – Hvítserkur, Jökulsárlón – Lodowcowa Laguna, Lasy Thora.",
          Polecamy: [
            {
              name:
                "Reykjavik, Snaefellsjökull, Sandvik, Hvannadalshnúkur, Lasy Thora",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, rejsy, trekking, tramping, wyprawy",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Belgia",
            urlgeo: "/belgia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "belgia",
            grupa: "1",
            url: "https://www.belgia.info.pl",
            photo: "BE-01.jpg",
            cenamin: "419"
          },
          Opis:
            "Kraj, który łączy tradycję z nowoczesnością, wielokulturowy, wielojęzyczny i różnorodny. Turystów przyciągają m.in. zabytkowe miasta, jak Bruksela – stolica czekolady i biurokracji, Antwerpia czy Brugia – flamandzka Wenecja, uzdrowiska Spa i Ostenda, Ardeny, znakomita infrastruktura sportowo-rekreacyjna oraz wyśmienita kuchnia.",
          Polecamy: [
            {
              name: "Bruksela, Antwerpia, Brugia, Charleroi, Gent, Waterloo",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, nordic walking, city breaks, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Litwa",
            urlgeo: "/litwa.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "litwa",
            grupa: "1",
            url: "https://www.litwa.info.pl",
            photo: "LT-01.jpg",
            cenamin: "1231"
          },
          Opis:
            "Ojczyzna Mickiewicza. Na nowo odkrywana przez Polaków Litwa to nie tylko Wilno, lecz ponad 1000 najważniejszych atrakcji, dziesiątki tras pieszych i rowerowych, centra sportowe i ośrodki wypoczynkowe, uzdrowiska, parki narodowe i krajobrazowe oraz znakomita kuchnia.",
          Polecamy: [
            {
              name: "Wilno, Druskienniki, Kłajpeda, Troki, Połąga",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, nordic walking, city breaks, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Albania",
            urlgeo: "/albania.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "albania",
            grupa: "1",
            url: "https://www.albania.info.pl",
            photo: "AL-01.jpg",
            cenamin: "519"
          },
          Opis:
            "Kraj bunkrów, koniaku „Skenderbeu”, Envera Hodży i Radia Tirana. Wciąż mało znana Albania, to znakomity pomysł na udane wakacje. Piękne plaże nad Adriatykiem i Morzem Jońskim, antyczne miasta, ufortyfikowane twierdze, smaczna kuchnia i barwny folklor przyciągają równie mocno, co przystępne ceny wczasów w Albanii.",
          Polecamy: [
            {
              name:
                "Tirana, Kruja, Saranda, Berat, Gjirokastra, Vlora, Butrint",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, rejsy, plażowanie, sporty wodne, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Belize",
            urlgeo: "/belize.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "belize",
            grupa: "9",
            url: "https://www.belize.com.pl",
            photo: "BZ-01.jpg",
            cenamin: []
          },
          Opis:
            "Idealne miejsce na rajskie wakacje! Wypoczynek w cieniu palm, z tropikalnym lasem w tle, wśród koralowych wysp i wciąż z dala od masowej turystyki. Cudowne krajobrazy, biały piasek rozległych plaż, Morze Karaibskie, dżungle i starożytne ruiny Majów. Jedyny kraj w regionie, gdzie angielski jest językiem urzędowym.",
          Polecamy: [
            {
              name: "Belize City, San Ignacio, Belmopan, Punta Gorda, Corozal",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, plażowanie, sporty wodne, rejsy, trekking, tramping, wyprawy, windsurfing, nurkowanie, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Bośnia i Hercegowina",
            urlgeo: "/bosnia-i-hercegowina.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "bosnia",
            grupa: "1",
            url: "https://www.bosnia.pl",
            photo: "BH-01.jpg",
            cenamin: "1049"
          },
          Opis:
            "Ta była republika jugosłowiańska to jedno z najbardziej „orientalnych” państw europejskich. Coraz popularniejszy cel wypraw i wycieczek objazdowych. Sarajewo, orientalne bazary, turecka dzielnica i most w Mostarze, Medjugorje – to najbardziej znane atrakcje Bośni i Hercegowiny.",
          Polecamy: [
            {
              name: "Sarajewo, Mostar, Medjugorje, Wyszegrad, Neum",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, plażowanie, sporty wodne, narty",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Kolumbia",
            urlgeo: "/kolumbia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "kolumbia",
            grupa: "10",
            url: "https://www.kolumbia.net.pl",
            photo: "CO-01.jpg",
            cenamin: "6179"
          },
          Opis:
            "Klejnot Ameryki Południowej. Kolumbia to świat w pigułce – rajskie Karaiby, dżungle Amazonii, tropikalne wybrzeża Pacyfiku, śnieżne Andy, sawanna Llanos, kolonialna architektura. Niegdyś kojarzona z kartelami narkotykowymi, dziś bezpieczna i otwarta na turystów. Pachnąca kawą Kolumbia to miejsce dobre na wypoczynek i wyprawę.",
          Polecamy: [
            {
              name: "Bogota, Cartagena, San Andreas, Soledad, Buenaventura",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, plażowanie, sporty wodne, rejsy, trekking, tramping, wyprawy, windsurfig, nurkowanie, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Serbia",
            urlgeo: "/serbia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "serbia",
            grupa: "1",
            url: "https://www.serbia.pl",
            photo: "RS-01.jpg",
            cenamin: "1670"
          },
          Opis:
            "Niezwykle ciekawy kraj położony na Półwyspie Bałkańskim. Pomimo tragicznej przeszłości jest to miejsce warte odwiedzenia i zupełnie bezpieczne. Historyczny Belgrad, Nowy Sad - stolica kultury i teatru, przełom Dunaju i twierdza Golubac w PN Đerdap, nieco kontrowersyjne (niepodległe) Kosowo, zabytki kultury sakralnej, atrakcje przyrodnicze oraz przepiękne góry.",
          Polecamy: [
            {
              name:
                "Belgrad, Nowy Sad, Novi Pazar, Guča,  Đavolja Varoš, Kosowo, Prisztina, Metohia, Peć",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, nordic walking,  wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Chile",
            urlgeo: "/chile.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "chile",
            grupa: "10",
            url: "https://www.chile.info.pl",
            photo: "CL-01.jpg",
            cenamin: "12025"
          },
          Opis:
            "Jedno z najciekawszych państw Ameryki Południowej o specyficznym kształcie - obejmuje wąski pas wzdłuż wybrzeża Oceanu Spokojnego o długości ponad 4 000 km. Różnorodne krajobrazy oraz niepowtarzalne atrakcje przyrodnicze - od pustyni po lodowcowe, wulkany, gezjery, plaże i niezliczone wyspy. Chile to także barwna kultura, ciekawe miasta, architektura kolonialna i wyśmienita kuchnia.",
          Polecamy: [
            {
              name:
                "Pustynia Atakama, Iquique, La Serena, Santiago de Chile, Valparaiso, Punta Arenas, Rapa Nui, Wyspa Robinsona Cruzoe",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, plażowanie, sporty wodne, rejsy, trekking, tramping, wyprawy, windsurfing, nurkowanie, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Namibia",
            urlgeo: "/namibia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "namibia",
            grupa: "7",
            url: "https://www.namibia.pl",
            photo: "NA-01.jpg",
            cenamin: "6979"
          },
          Opis:
            "Państwo w Afryce Południowo-Zachodniej nad Oceanem Atlantyckim. Pustynia Kalahari i pustynia Namib, kanion Fish River, Park Narodowy Etosha, Skeleton Coast na wybrzeżu, Windhoek i Swakopmund. Idealne miejsce na wypoczynek i wyprawę. Piękne plaże, egzotyczne krajobrazy, safari oraz bajeczne widoki - Namibia to raj dla fotografów.",
          Polecamy: [
            {
              name:
                "Windhoek, Swakpmund, Park Narodowy Etosha, Skeleton Coast, Kanion Fish River, Rezerwat Caprivi, Pustynia Namib, Pustynia Kalahari",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "aktywny wypoczynek, zwiedzanie, plażowanie, sporty wodne, safari, wyprawy, windsurfing, nurkowanie, wypoczynek, objazdówki",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Szwecja",
            urlgeo: "/szwecja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "szwecja",
            grupa: "1",
            url: "https://www.szwecja.info.pl",
            photo: "SE-01.jpg",
            cenamin: "649"
          },
          Opis:
            "Ten skandynawski kraj od lat cieszy się powodzeniem wśród turystów doceniających jego niezwykłą różnorodność. Jest to idealny wybór dla osób lubiących aktywny wypoczynek i zwiedzanie. Sztokholm, Göteborg, Malmo, gęstę lasy, potężne rzeki, mroźna północ oraz łagodne południe. Lodowy Hotel Jukkasjärvi, liczne festiwale i wydarzenia kulturalne.",
          Polecamy: [
            {
              name:
                "Sztokholm, Goteborg, Malmo, Gotlandia, Uppsala, Laponia, Hotel Lodowy",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, trekking, tramping, wyprawy, wypoczynek, city breaks",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Łotwa",
            urlgeo: "/lotwa.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "lotwa",
            grupa: "1",
            url: "https://www.lotwa.info.pl",
            photo: "LV-01.jpg",
            cenamin: "649"
          },
          Opis:
            "Jeden z krajów nadbałtyckich, który, choć leży niedaleko Polski, wciąż jest stosunkowo mało znany. Przepiękna Ryga, słynne uzdrowisko Jurmała, zachwycające pojezierze, secesyjny Dyneburg, zabytkowa Windawa oraz zachwycająca Kurlandia. Łotwa to kraj interesujący, o bogatej kulturze, ciekawej historii i barwnym folklorze.",
          Polecamy: [
            {
              name:
                "Ryga, Jurmała, Windawa, Dyneburg, Park Narodowy Gauji, Pojezierze Łatgalskie",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, nordic walking, city breaks, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Estonia",
            urlgeo: "/estonia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "estonia",
            grupa: "1",
            url: "https://www.estonia.info.pl",
            photo: "EE-01.jpg",
            cenamin: "1139"
          },
          Opis:
            "Historyczny Tallinn, Jezioro Pejpus, Park Narodowy Lahemaa, Tartu, wyspy Kihnu i Ruhnu, Parnawa oraz zabytkowe Haapsalu. Estonia to kraj ciekawy o bogatej ofercie turystycznej, dobra na zwiedzanie i wyprawy, wypoczynek oraz zabawę w miastach i na licznych festiwalach. Niezwykle ciekawy kraj o żywych tradycjach i ciekawej kulturze, który z roku na rok cieszy się coraz większą popularnością.",
          Polecamy: [
            {
              name:
                "Tallin, Haapsalu, Park Narodowy Lahema, Tartu, Parnawa, Jezioro Pejpus, Zatoka Ryska, Zatoka Fińska",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, nordic walking, city breaks, wypoczynek",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Macedonia",
            urlgeo: "/macedonia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "macedonia",
            grupa: "1",
            url: "https://www.macedonia.net.pl",
            photo: "MK-01.jpg",
            cenamin: "1573"
          },
          Opis:
            "Niewielkie państwo południowosłowiańskie o różnorodnych wpływach kulturowych i mieszance narodowo-etnicznej. Letni kurort i centrum kulturalne Ochryda nad jeziorem Ochrydzkim, malowniczy św. Naum, komunistyczna zabudowa Skopie, ośrodki sportów zimowych i greckie krajobrazy na południu. Wyśmienita kuchnia narodowa i niezwykle gościnni mieszkańcy!",
          Polecamy: [
            {
              name:
                "Skopie, Ochryda, Prespa, Bitola, Jezioro Tikveš, Prespa, Šar Planina, sv. Naum",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name:
                "objazdówki, aktywny wypoczynek, zwiedzanie, plażowanie, trekking, tramping, wyprawy, wypoczynek, city break",
              url: ""
            }
          ]
        }
      ],
      grupypanstw: [
        {
          id: "1",
          name: "Europa"
        },
        {
          id: "2",
          name: "Bliski Wschód"
        },
        {
          id: "3",
          name: "Azja Południowa"
        },
        {
          id: "4",
          name: "Azja Południowo-Wschodnia"
        },
        {
          id: "5",
          name: "Australia i Oceania"
        },
        {
          id: "6",
          name: "Afryka Północna"
        },
        {
          id: "7",
          name: "Afryka Wschodnia"
        },
        {
          id: "8",
          name: "Afryka Południowa"
        },
        {
          id: "9",
          name: "Ameryka Środkowa i Karaiby"
        },
        {
          id: "10",
          name: "Ameryka Południowa"
        },
        {
          id: "11",
          name: "Ameryka Północna"
        }
      ]
    }
  }
};
